(function () {
  'use strict';

  // === GLOBAL HEADER SEARCH (runs on every page; safe before early return) ===
  (function(){
    // avoid double-binding if this file runs twice
    if (window.__SF_headerSearchBound) return;
    window.__SF_headerSearchBound = true;

    function bind(){
      var headerBox = document.getElementById('header-products-search-bar');
      if (!headerBox) return;

      function onSubmitQuery(q){
        q = (q || '').trim();
        if (!q) return;

        // Are we on /collections/all ?
        var onAll = (function(){
          try{
            var u = new URL(window.location.href);
            var parts = u.pathname.split('/').filter(Boolean);
            return (parts[0] === 'collections' && parts[1] === 'all');
          }catch(_){ return false; }
        })();

        if (onAll) {
          if (window.__SF_setKeywordAndSearch) {
            window.__SF_setKeywordAndSearch(q);     // search in-place
          } else {
            var u = new URL(window.location.href);  // fallback: reload with ?q=
            u.searchParams.set('q', q);
            window.location.href = u.toString();
          }
        } else {
          window.location.href = '/collections/all?q=' + encodeURIComponent(q);
        }
      }

      // Grab form robustly (covers themes that nest inputs)
      var form = headerBox.closest ? headerBox.closest('form') : (headerBox.form || null);

      // 1) Intercept FORM SUBMIT at CAPTURE phase to beat theme handlers
      if (form) {
        form.addEventListener('submit', function(e){
          // Stop the native /search?type=product submit
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          onSubmitQuery(headerBox.value);
          return false;
        }, true); // <-- capture!
      }

      // 2) Also intercept Enter directly on the input
      headerBox.addEventListener('keydown', function(e){
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          onSubmitQuery(headerBox.value);
        }
      }, true); // capture helps beat other listeners

      // 3) Some browsers fire a 'search' event on input[type=search]
      headerBox.addEventListener('search', function(e){
        // Optional: run on clear or enter; here only run if non-empty
        if ((headerBox.value || '').trim()) {
          e.preventDefault();
          e.stopPropagation();
          onSubmitQuery(headerBox.value);
        }
      }, true);

      // 4) Optional button next to the header input
      var btn = document.getElementById('header-products-search-btn');
      if (btn) {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          onSubmitQuery(headerBox.value);
        }, true);
      }
    }

    // Bind now (if element already exists), and also watch for late-added headers
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind, { once:true });
    } else {
      bind();
    }

    // Handle themes that inject the header after load
    var mo = new MutationObserver(function(){
      if (document.getElementById('header-products-search-bar')) {
        bind();
        try { mo.disconnect(); } catch(_) {}
      }
    });
    try {
      mo.observe(document.documentElement, { childList:true, subtree:true });
    } catch(_){}
  })();



  // --- perf: feature-detection helpers ---
  var rIC = window.requestIdleCallback || function(cb){ return setTimeout(cb, 1); };
  function inViewportOnce(el, cb){
    if (!('IntersectionObserver' in window)) return cb(); // fallback
    var seen = false;
    var io = new IntersectionObserver(function(list){
      if (seen) return;
      if (list.some(function(e){ return e.isIntersecting; })){
        seen = true; io.disconnect(); cb();
      }
    }, { rootMargin: '200px' });
    io.observe(el);
  }


  // ===== Config =====
  // If you added the theme setting + window.__SF_TOKEN in theme.liquid, this will pick it up.
  // Otherwise, replace the fallback string with your real Storefront token.
  var SF_TOKEN   = window.__SF_TOKEN || 'da11ae549267d55ed1e51eeab82f921e';
  var SF_VERSION = '2025-07';
  var ENDPOINT   = '/api/' + SF_VERSION + '/graphql.json';

  // --- SALE landing wiring ---
  var SALE_COLLECTION_HANDLE = 'running-shoe-sale-kansas-city';  // the handle of your empty "Sale" collection
  var ALL_PRODUCTS_HANDLE    = 'all';   // wide collection to fetch from (e.g. Shopify "All" collection)
  var __handleOverride       = null;    // when set, forces queries to use this handle

  var __lastNonSaleHandle = null; // remember where to return when unchecking "Sale"



  // --- keyword search state ---
  var __keyword = ''; // when non-empty, we ignore all other filters


  // Map URL query params -> metafields (namespace.key)
  // Example: ...&activity=Running  -->  productMetafield: { namespace:"custom", key:"online_feel_child_2", value:"Running" }
  var URL_META_MAP = {
    activity: 'custom.online_feel_child_2',   // ?activity=Running
    type_of_feel: 'custom.online_feel3',      // ?type_of_feel=Lightweight
    what_doing_in_the_gym: 'custom.what_doing_in_the_gym', // ?gym_activity=Cardio
    'footwear-width': {
      name: 'footwear_width[]'
    },
    // Width
    'width': { name: 'footwear_width[]', namespace: 'custom', key: 'online_width' }

  };

  // Which checkbox group should a URL param drive?
  // (values must match the checkbox "value" attributes in your HTML)
  var PARAM_TO_INPUT_NAME = {
    activity:        'footwear_activity[]',
    type_of_feel:    'footwear_feel[]',
    width: 'footwear_width[]',

    // NEW: URL type 1 → footwear size e.g. ?footwear-size=8
    'footwear-size': 'footwear_size[]',

    // NEW: URL type 2 → clothing type e.g. ?clothing-type=HALF%20ZIP
    'clothing-type': 'clothing_type[]',

    // NEW: URL type 3 → brand/vendor e.g. ?brand=ALTRA
    'brand':         'brands[]'
    // (values must match the checkbox value attributes in your HTML)
  };



  // Checkbox groups under Footwear accordion → metafields
  // Uses input[name="..."] so you don’t have to list every ID.
  var FOOTWEAR_GROUP_META_MAP = {
    'footwear_feel[]':     { namespace: 'custom', key: 'online_feel3' },          // Feel
    'footwear_activity[]': { namespace: 'custom', key: 'online_feel_child_2' }   // Activity
    // 'footwear_injury[]':   { namespace: 'custom', key: 'online_injury' }          // Injury  ✅
  };

  // EXACT option name as shown in Shopify (case-sensitive)
  var FOOTWEAR_SIZE_NAME = 'Size';
  var FOOTWEAR_SIZE_INPUT_NAME = 'footwear_size[]';

  var COLOR_OPTION_NAME = 'Color';




  // ===== Accessories (metafields) =====
  var ACCESSORY_INPUT_NAME = 'accessories[]'; // matches your HTML
  var ACCESSORY_PARENT_META = { namespace: 'custom', key: 'online_shop_left_hand_filters', value: 'Accessories' };
  var ACCESSORY_CHILD_META_KEY = { namespace: 'custom', key: 'online_child_category' };
  var FOOTWEAR_WIDTH_META_KEY = { namespace: 'custom', key: 'online_width' };


  // ===== Sports Medicine & Recovery (metafields) =====
  var SMR_INPUT_NAME = 'smr[]'; // matches your HTML
  var SMR_PARENT_META = { namespace: 'custom', key: 'online_shop_left_hand_filters', value: 'Sports Medicine & Recovery' };
  var SMR_CHILD_META_KEY = { namespace: 'custom', key: 'online_sports_medicine_recovery' };

  // ===== Clothing (Type + Size) =====
  var CLOTHING_TYPE_INPUT_NAME = 'clothing_type[]';   // from your HTML
  var CLOTHING_SIZE_INPUT_NAME = 'clothing_size[]';   // from your HTML
  var CLOTHING_SIZE_OPTION_NAME = 'Size';             // variant option name shown in Shopify




 // ===== Category definitions for exclusivity + routing (gender-aware + explicit ids) =====
  var CATEGORY_DEFS = {
    footwear: {
      handle: 'all-footwear',                // ← was 'mens-footwear-1'
      masterId: 'checkboxAllFootwear',
      childNames: ['footwear_gender[]','footwear_feel[]','footwear_activity[]','footwear_injury[]','footwear_size[]'],
      genderName: 'footwear_gender[]',
      genderIds: { men: 'fw-gender-men', women: 'fw-gender-women' },
      handlesByGender: {
        men:   'mens-footwear-1',
        women: 'womens-footwear-1'
      }
    },
    clothing: {
      handle: 'all-apparel',                 // ← was 'mens-apparel-1'
      masterId: 'checkboxAllClothing',
      childNames: ['clothing_gender[]','clothing_type[]','clothing_size[]'],
      genderName: 'clothing_gender[]',
      genderIds: { men: 'cl-gender-men', women: 'cl-gender-women' },
      handlesByGender: {
        men:   'mens-apparel-1',
        women: 'womens-apparel-1'
      }
    },
    accessories: {
      handle: 'accessories-1',
      masterId: 'acc-all',
      childNames: ['accessories[]']
    },
    smr: {
      handle: 'sports-medicine-recovery',
      masterId: 'smr-all',
      childNames: ['smr[]']
    }
  };

  // Reentrancy guard so child listeners don't uncheck the master
  var __suppressMasterSync = { footwear:false, clothing:false, accessories:false, smr:false };

  
  var __bulkClearing = false;


  function withSuppression(key, fn){
    __suppressMasterSync[key] = true;
    try { fn && fn(); } finally { __suppressMasterSync[key] = false; }
  }


  function uncheckByName(nameAttr){
    document.querySelectorAll('input[name="'+nameAttr+'"]:checked').forEach(function(el){
      el.checked = false;
    });
  }

  function uncheckCategoryChildren(key){
    var def = CATEGORY_DEFS[key];
    if (!def) return;
    def.childNames.forEach(uncheckByName);
  }

  function syncMasterWithChildren(key){
    var def = CATEGORY_DEFS[key];
    if (!def || !def.masterId) return;
    var master = document.getElementById(def.masterId);
    if (!master) return;

    // Consider "children" as checked inputs EXCLUDING the master
    var anyRealChildChecked = def.childNames.some(function(nameAttr){
      var checked = Array.prototype.slice.call(
        document.querySelectorAll('input[name="' + nameAttr + '"]:checked')
      );
      return checked.some(function(el){ return el !== master; });
    });

    // If any real child is checked, master should be unchecked
    if (anyRealChildChecked && master.checked) master.checked = false;
  }


  function getSelectedSizes() {
    var inputs = document.querySelectorAll('input[name="' + FOOTWEAR_SIZE_INPUT_NAME + '"]:checked');
    var sizes = [];
    inputs.forEach(function (el) {
      var v = (el.value || '').trim();
      if (v) sizes.push(v);
    });
    return sizes;
  }

  function getSelectedAccessoryTypes() {
    var inputs = document.querySelectorAll('input[name="' + ACCESSORY_INPUT_NAME + '"]:checked');
    var out = [];
    inputs.forEach(function (el) {
      // Skip the “All Accessories” master checkbox (id="acc-all")
      if (el.id === 'acc-all') return;
      var v = (el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  function getSelectedSmrTypes() {
    var inputs = document.querySelectorAll('input[name="' + SMR_INPUT_NAME + '"]:checked');
    var out = [];
    inputs.forEach(function (el) {
      // Skip the “All Sports Medicine & Recovery” master checkbox (id="smr-all")
      if (el.id === 'smr-all') return;
      var v = (el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  function getSelectedClothingTypes() {
    var inputs = document.querySelectorAll('input[name="' + CLOTHING_TYPE_INPUT_NAME + '"]:checked');
    var out = [];
    inputs.forEach(function (el) {
      var v = (el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  function getSelectedClothingSizes() {
    var inputs = document.querySelectorAll('input[name="' + CLOTHING_SIZE_INPUT_NAME + '"]:checked');
    var sizes = [];
    inputs.forEach(function (el) {
      var v = (el.value || '').trim();
      if (v) sizes.push(v);
    });
    return sizes;
  }

  /**
   * Generic "active category sizes" resolver so your multi-size code keeps working.
   * If Clothing category is active -> use clothing sizes
   * If Footwear category is active -> use footwear sizes
   * Else -> []
   */
  function getActiveSizes() {
    if (typeof isCategoryActive === 'function') {
      if (isCategoryActive('clothing'))  return getSelectedClothingSizes();
      if (isCategoryActive('footwear'))  return getSelectedSizes(); // your existing footwear size getter
    }
    return [];
  }




  function syncURLCollectionHandle(newHandle) {
    // Do NOT rewrite the path when we're on /collections/sale and using an override.
    try {
      var u0 = new URL(window.location.href);
      var parts0 = u0.pathname.split('/').filter(Boolean);
      var onSaleRoute = (parts0[0] === 'collections' && parts0[1] === SALE_COLLECTION_HANDLE);
      if (onSaleRoute && __handleOverride) return; // keep URL as /collections/sale
    } catch(_){}

    try {
      var u = new URL(window.location.href);
      var parts = u.pathname.split('/').filter(Boolean); // remove empty
      var idx = parts.indexOf('collections');
      if (idx !== -1 && parts[idx + 1] && parts[idx + 1] !== newHandle) {
        parts[idx + 1] = newHandle;
        u.pathname = '/' + parts.join('/');
        history.replaceState(null, '', u.toString());
      }
    } catch (e) {
      /* ignore */
    }
  }



  function anyCheckedByName(nameAttr) {
    return !!document.querySelector('input[name="' + nameAttr + '"]:checked');
  }

  function isCategoryActive(key) {
    var def = CATEGORY_DEFS[key];
    if (!def) return false;
    if (def.masterId) {
      var m = document.getElementById(def.masterId);
      if (m && m.checked) return true;
    }
    for (var i = 0; i < def.childNames.length; i++) {
      if (anyCheckedByName(def.childNames[i])) return true;
    }
    return false;
  }

  function clearCategory(key) {
    var def = CATEGORY_DEFS[key];
    if (!def) return;
    // Uncheck master
    if (def.masterId) {
      var m = document.getElementById(def.masterId);
      if (m) m.checked = false;
    }
    // Uncheck all children
    def.childNames.forEach(function(nameAttr){
      document.querySelectorAll('input[name="' + nameAttr + '"]:checked').forEach(function(el){
        el.checked = false;
      });
    });
  }

  /**
   * Activate a category: clear others, sync URL to that category's handle, then runSearch()
   * Use when a user checks *anything* within a category (master or child).
   */
/**
 * Activate a category: clear others, optionally wipe URL params if we switched categories,
 * sync URL to that category's handle, then runSearch()
 * Use when a user checks *anything* within a category (master or child).
 */
  function activateCategory(key) {
    __handleOverride = null; // stop forcing "all" once user actively navigates categories

    // Helper: which categories are currently active *before* we modify anything
    function getActiveCategoryKeys(){
      return Object.keys(CATEGORY_DEFS).filter(function(k){ return isCategoryActive(k); });
    }

    var prevActive = getActiveCategoryKeys();

    // Clear other categories, keep current
    Object.keys(CATEGORY_DEFS).forEach(function(other){
      if (other !== key) clearCategory(other);
    });

    var def = CATEGORY_DEFS[key];

    // Read the current path handle once (before we possibly change it)
    var pathHandle = (function(){
      try {
        var u = new URL(window.location.href);
        var parts = u.pathname.split('/').filter(Boolean);
        return (parts[0] === 'collections' && parts[1]) ? parts[1] : null;
      } catch(_){ return null; }
    })();

    var targetHandle = def && def.handle;
    var g = getGenderForCategory(key);

    // If gender is explicitly selected and a gendered handle exists → use that
    if (def && def.handlesByGender && g && def.handlesByGender[g]) {
      targetHandle = def.handlesByGender[g];
    } else if ((key === 'footwear' || key === 'clothing') && def && def.handlesByGender) {
      // If gender NOT selected, but current path belongs to this category → keep it
      var known = Object.values(def.handlesByGender || {});
      if (pathHandle && known.indexOf(pathHandle) !== -1) {
        targetHandle = pathHandle;
      }
    }

    // Determine if we truly switched categories (was something else active before?)
    var switched = prevActive.some(function(k){ return k !== key; });

    // If we switched categories, wipe ALL URL filter params + reset price UI
    if (switched) {
      clearAllFilterParamsFromURL();         // removes price, mapped params, brand/clothing-type, and sort_by
      clearPriceFromURLAndResetSliderUI();   // visually reset slider too
    }

    if (targetHandle) syncURLCollectionHandle(targetHandle);
    requestSearch();
  }



  function getGenderForCategory(key) {
    var def = CATEGORY_DEFS[key];
    if (!def || !def.genderName) return null;

    // 1) Prefer explicit id check (zero ambiguity)
    if (def.genderIds) {
      var menEl   = def.genderIds.men   ? document.getElementById(def.genderIds.men)   : null;
      var womenEl = def.genderIds.women ? document.getElementById(def.genderIds.women) : null;
      if (womenEl && womenEl.checked) return 'women';
      if (menEl && menEl.checked)     return 'men';
    }

    // 2) Fallback: scan checked inputs by name (in case ids changed)
    var checked = document.querySelectorAll('input[name="' + def.genderName + '"]:checked');
    if (!checked.length) return null;

    function norm(s){
      return String(s || '').toLowerCase().trim().replace(/[’']/g, "'");
    }
    for (var i = 0; i < checked.length; i++) {
      var id  = norm(checked[i].id);
      var val = norm(checked[i].value);
      if (id.includes('women') || val === 'women' || val === 'womens' || val.includes("women'")) return 'women';
      if (id.includes('men')   || val === 'men'   || val === 'mens'   || val.includes("men'"))   return 'men';
    }
    return null;
  }





  // Category master checkboxes -> collection handle overrides
  // Fill in the *actual* handles of your smart collections.
  var COLLECTION_CHECKBOX_MAP = {
    'checkboxAllFootwear':  'all-footwear',     // ← was 'mens-footwear-1'
    'checkboxAllClothing':  'all-apparel',      // ← was 'mens-apparel-1'
    'acc-all':              'accessories-1',
    'smr-all':              'sports-medicine-recovery'
  };



  // Category checkboxes (values come from the input's value attribute)
  var CHECKBOX_MAP = {
    'checkboxAllFootwear':  { kind: 'tag' },
    'checkboxAllClothing':  { kind: 'tag' },
    'acc-all':              { kind: 'tag' }, // Accessories (top-level)
    'smr-all':              { kind: 'tag' }  // Sports Medicine & Recovery (top-level)
  };



  // ===== DOM refs =====
  var ui        = document.getElementById('sf-metafield-filters');
  var resultsEl = document.getElementById('sf-results');
  var countEl   = document.getElementById('sf-count');

  if (!ui || !resultsEl) return; // not on a collection page with our UI

  // Hide theme's native grid if you wrapped it with id="theme-collection-grid"
  var themeGrid = document.getElementById('theme-collection-grid');
  if (themeGrid) themeGrid.style.display = 'none';

  // Read the collection handle from the page
  var collectionHandle = ui.getAttribute('data-collection-handle');

  // Controls
  var btnApply = document.getElementById('sf-apply-filters');
  var btnClear = document.getElementById('btn-clear-all-filters');

  // Selector for our checkboxes (inside groups)
  var CHECKS_SELECTOR = '#sf-metafield-filters .sf-group input[type="checkbox"], #sf-metafield-filters .sf-filter-list input[type="checkbox"]';

  // Keep a copy of currently rendered nodes (for count + load more)
  // ===== Pagination state =====

  // ----- Infinite Scroll (feature flag + state) -----
  var INFINITE_ENABLED = true;            // toggle on/off here
  var __inf = { observer: null, loading: false }; // guard to prevent double fetches

  function getTotalShown(){
    var total = 0;
    Object.keys(pageState.pages).forEach(function(k){
      var p = pageState.pages[k];
      if (p && p.nodes) total += p.nodes.length;
    });
    return total;
  }

  var PAGE_SIZE = 0;

  const paramsNew = new URLSearchParams(window.location.search);

  if (paramsNew.get("fit-finder") === "true") {
      PAGE_SIZE = 5; 
      $('.collection-page-main-container-wrapper').addClass('throgh-fit-finder');
  } else {
      PAGE_SIZE = 16; 
  }


                   // how many products per page
  var currentNodes = [];               // products currently shown
  var pageState = {
    current: 1,                        // current page number (1-based)
    pages: {},                         // { [pageNum]: { nodes, pageInfo } }
    cursors: [null],                   // cursors[i] = endCursor of page i (index 0 is null for page 1)
    hasNext: true,                     // whether there is a next page from the last fetched one
    maxFetched: 0                      // highest page number we have fetched
  };

  // === Server paging controls (reduce number of requests) ===
  var SERVER_PAGE_CHUNK = 150;  // how many products to request per API call
  var MAX_SCAN_PAGES    = 10;    // hard cap: max scans to fill one UI page



  // --- products, NO keyword (safe on all API versions)
  // Compact (no variants), no keyword
  var QUERY_PRODUCTS_COMPACT_NOQ = `
    query ProductsCompact($handle:String!, $first:Int!, $after:String,
                          $filters:[ProductFilter!], $sortKey: ProductCollectionSortKeys, $reverse:Boolean){
      collection(handle:$handle){
        products(first:$first, after:$after, filters:$filters, sortKey:$sortKey, reverse:$reverse){
          pageInfo{ hasNextPage endCursor }
          nodes{
            id
            handle
            title
            injuryMetafield: metafield(namespace: "custom", key: "online_injury") { value }
            vendor
            priceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            compareAtPriceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            images(first: 20){
              nodes{
                url
                altText
              }
            }
            variants(first: 100){
              nodes{
                id
                availableForSale
                price{
                  amount
                  currencyCode
                }
                compareAtPrice{
                  amount
                  currencyCode
                }
                selectedOptions{
                  name
                  value
                }
                image{
                  url
                  altText
                }
              }
            }
            collections(first: 10){
              nodes{
                handle
              }
            }
          }
        }
      }
    }
  `;




  // Full (variants + activity), no keyword
  const QUERY_PRODUCTS_FULL_NOQ = `
    query ProductsFull($handle:String!, $first:Int!, $after:String,
                      $filters:[ProductFilter!], $sortKey: ProductCollectionSortKeys, $reverse:Boolean){
      collection(handle:$handle){
        products(first:$first, after:$after, filters:$filters, sortKey:$sortKey, reverse:$reverse){
          pageInfo{ hasNextPage endCursor }
          nodes{
            id
            handle
            title
            injuryMetafield: metafield(namespace: "custom", key: "online_injury") { value }
            vendor
            priceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            compareAtPriceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            images(first: 20){
              nodes{
                url
                altText
              }
            }
            variants(first: 100){
              nodes{
                id
                availableForSale
                price{
                  amount
                  currencyCode
                }
                compareAtPrice{
                  amount
                  currencyCode
                }
                selectedOptions{
                  name
                  value
                }
                image{
                  url
                  altText
                }
              }
            }
            activityMF: metafield(namespace:"custom", key:"online_feel_child_2"){
              value
            }
            collections(first: 10){
              nodes{
                handle
              }
            }
          }
        }
      }
    }
  `;







  // --- NEW: Root-level (all products) queries for /collections/all ---
  var QUERY_PRODUCTS_COMPACT_ALL_NOQ = `
    query ProductsAllCompact($first:Int!, $after:String,
                            $sortKey: ProductSortKeys, $reverse:Boolean){
      products(first:$first, after:$after, sortKey:$sortKey, reverse:$reverse){
        pageInfo{ hasNextPage endCursor }
        nodes{
          id handle title vendor
          priceRange{ minVariantPrice{ amount currencyCode } }
          compareAtPriceRange{ minVariantPrice{ amount currencyCode } }
          images(first: 4){ nodes{ url altText } }
        }
      }
    }`;

  // NEW: fast keyword search on /collections/all using the Storefront "query" arg
  var QUERY_PRODUCTS_SEARCH_ALL = `
    query ProductsAllSearch($first:Int!, $after:String, $q:String,
                            $sortKey: ProductSortKeys, $reverse:Boolean){
      products(first:$first, after:$after, sortKey:$sortKey, reverse:$reverse, query:$q){
        pageInfo{ hasNextPage endCursor }
        nodes{
          id
          handle
          title
          injuryMetafield: metafield(namespace: "custom", key: "online_injury") { value }
          vendor
          priceRange{
            minVariantPrice{
              amount
              currencyCode
            }
          }
          compareAtPriceRange{
            minVariantPrice{
              amount
              currencyCode
            }
          }
          images(first: 20){
            nodes{
              url
              altText
            }
          }
          variants(first: 100){
            nodes{
              id
              availableForSale
              price{
                amount
                currencyCode
              }
              compareAtPrice{
                amount
                currencyCode
              }
              selectedOptions{
                name
                value
              }
              image{
                url
                altText
              }
            }
          }
          activityMF: metafield(namespace:"custom", key:"online_feel_child_2"){
            value
          }
        }
      }
    }
  `;


    var QUERY_PRODUCTS_FULL_ALL_NOQ = `
      query ProductsAll($first:Int!, $after:String, $sortKey: ProductSortKeys, $reverse:Boolean){
        products(first:$first, after:$after, sortKey:$sortKey, reverse:$reverse){
          pageInfo{ hasNextPage endCursor }
          nodes{
            id
            handle
            title
            injuryMetafield: metafield(namespace: "custom", key: "online_injury") { value }
            vendor
            priceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            compareAtPriceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            images(first: 20){
              nodes{
                url
                altText
              }
            }
            variants(first: 100){
              nodes{
                id
                availableForSale
                price{
                  amount
                  currencyCode
                }
                compareAtPrice{
                  amount
                  currencyCode
                }
                selectedOptions{
                  name
                  value
                }
                image{
                  url
                  altText
                }
              }
            }
            activityMF: metafield(namespace:"custom", key:"online_feel_child_2"){
              value
            }
            collections(first: 10){
              nodes{
                handle
              }
            }
          }
        }
      }
    `;




// === No-Filters versions for unknown/custom collections ===
var QUERY_PRODUCTS_COMPACT_NOFILTERS = `
  query ProductsCompactNoFilters($handle:String!, $first:Int!, $after:String,
                                 $sortKey: ProductCollectionSortKeys, $reverse:Boolean){
    collection(handle:$handle){
      products(first:$first, after:$after, sortKey:$sortKey, reverse:$reverse){
        pageInfo{ hasNextPage endCursor }
        nodes{
          id handle title vendor
          priceRange{ minVariantPrice{ amount currencyCode } }
          compareAtPriceRange{ minVariantPrice{ amount currencyCode } }
          images(first: 4){ nodes{ url altText } }
          collections(first: 10){ nodes{ handle } }
        }
      }
    }
  }`;

  var QUERY_PRODUCTS_FULL_NOFILTERS = `
    query ProductsFullNoFilters($handle:String!, $first:Int!, $after:String,
                                $sortKey: ProductCollectionSortKeys, $reverse:Boolean){
      collection(handle:$handle){
        products(first:$first, after:$after, sortKey:$sortKey, reverse:$reverse){
          pageInfo{ hasNextPage endCursor }
          nodes{
            id handle title vendor
            priceRange{ minVariantPrice{ amount currencyCode } }
            compareAtPriceRange{ minVariantPrice{ amount currencyCode } }
            images(first: 4){ nodes{ url altText } }
            variants(first: 100){
              nodes{
                availableForSale
                price{ amount currencyCode }
                compareAtPrice{ amount currencyCode }
                selectedOptions{ name value }
                image{ url altText }      
              }
            }
            activityMF: metafield(namespace:"custom", key:"online_feel_child_2"){ value }
            collections(first: 10){ nodes{ handle } }
          }
        }
      }
    }`;




  // --- LIGHT scan query for expensive client-side filters (injury/color)
  // Keeps enough data for rendering + matching, but much smaller than QUERY_PRODUCTS_FULL_NOQ
  var QUERY_PRODUCTS_SCAN_LIGHT_NOQ = `
    query ProductsScanLight($handle:String!, $first:Int!, $after:String,
                            $filters:[ProductFilter!], $sortKey: ProductCollectionSortKeys, $reverse:Boolean){
      collection(handle:$handle){
        products(first:$first, after:$after, filters:$filters, sortKey:$sortKey, reverse:$reverse){
          pageInfo{ hasNextPage endCursor }
          nodes{
            id
            handle
            title
            injuryMetafield: metafield(namespace: "custom", key: "online_injury") { value }
            vendor
            priceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            compareAtPriceRange{
              minVariantPrice{
                amount
                currencyCode
              }
            }
            images(first: 6){
              nodes{
                url
                altText
              }
            }
            variants(first: 35){
              nodes{
                availableForSale
                price{
                  amount
                  currencyCode
                }
                compareAtPrice{
                  amount
                  currencyCode
                }
                selectedOptions{
                  name
                  value
                }
                image{
                  url
                  altText
                }
              }
            }
            activityMF: metafield(namespace:"custom", key:"online_feel_child_2"){
              value
            }
          }
        }
      }
    }
  `;

    // Get the highest price product in a collection (fast: 1 result sorted by PRICE desc)
    var QUERY_MAX_PRICE =
    'query MaxPrice($handle:String!) {' +
    '  collection(handle:$handle){' +
    '    products(first:1, sortKey: PRICE, reverse:true){' +
    '      nodes{' +
    '        priceRange{ maxVariantPrice{ amount currencyCode } }' +
    '      }' +
    '    }' +
    '  }' +
    '}';

    // --- NEW: Max price across all products (root) ---
    var QUERY_MAX_PRICE_ALL = `
      query MaxPriceAll {
        products(first:1, sortKey: PRICE, reverse:true){
          nodes{
            priceRange{ maxVariantPrice{ amount currencyCode } }
          }
        }
      }`;

    
  // --- Route + activity helpers (go here, above "// --------- URL helpers ---------")
  function isOnCollectionHandle(h){
    try{
      var parts = (new URL(window.location.href)).pathname.split('/').filter(Boolean);
      return parts[0] === 'collections' && parts[1] === h;
    }catch(_){ return false; }
  }

  // REPLACE your existing anyUIOrURLFilterActive() with this
  function anyUIOrURLFilterActive() {
    // Treat keyword (?q=) as an active filter so the "all" page doesn't auto-load everything again.
    try {
      var q = new URL(window.location.href).searchParams.get('q');
      if (q && q.trim() !== '') return true;
    } catch (_) {}

    // Price in URL
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('filter.v.price.gte') || u.searchParams.has('filter.v.price.lte')) {
        return true;
      }
      // activity & type_of_feel in URL
      if (u.searchParams.get('activity')) return true;
      if (u.searchParams.get('type_of_feel')) return true;
      // brand filter(s) in URL (if you use brands[]= or similar)
      if (u.searchParams.getAll && u.searchParams.getAll('brands[]').length) return true;
      if (u.searchParams.get('brand')) return true;
      // sale-only flag you might set in URL
      if (u.searchParams.get('sale') === '1') return true;
    } catch (_) {}

    // UI checks (checkboxes, selects, etc.)
    var root = document.querySelector('.left-side-filters-container') || document;
    if (!root) return false;

    // Any checked checkboxes?
    var checked = root.querySelector('input[type="checkbox"]:checked');
    if (checked) return true;

    // Any non-default selects?
    var selects = root.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].selectedIndex > 0) return true;
    }

    // Keyword input in the left rail
    var kw = document.getElementById('keyword-search-input');
    if (kw && kw.value && kw.value.trim() !== '') return true;

    // Price slider moved from default min/max?
    var minR = document.getElementById('minRange');
    var maxR = document.getElementById('maxRange');
    if (minR && maxR) {
      var minDefault = Number(minR.getAttribute('min') || 0);
      var maxDefault = Number(maxR.getAttribute('max') || maxR.getAttribute('min') || 0);
      var minVal = Number(minR.value);
      var maxVal = Number(maxR.value);
      if (isFinite(minVal) && isFinite(maxVal) && (minVal !== minDefault || maxVal !== maxDefault)) {
        return true;
      }
    }

    return false;
  }


  // --------- URL helpers ---------
  function getURLParams() {
    try { return new URLSearchParams(window.location.search || ''); }
    catch (e) { return new URLSearchParams(''); }
  }
  

    // --- URL → UI sync (pre-check boxes, open accordions, set price) ---
    function getURLMultiValues(param){
      var params = getURLParams();
      // supports repeated params AND comma-separated lists
      var out = [];
      var seen = {};
      params.getAll(param).forEach(function(raw){
        String(raw).split(',').forEach(function(piece){
          var v = piece.trim();
          if (!v) return;
          if (!seen[v]) { seen[v] = true; out.push(v); }
        });
      });
      return out;
    }

  // --- NEW: URL write-back helpers (keep URL in sync with current UI) ---
  function getCheckedValuesByName(nameAttr){
    var out = [];
    document.querySelectorAll('input[name="'+nameAttr+'"]:checked').forEach(function(el){
      // ignore masters that shouldn't produce URL params
      if (el.id === 'acc-all' || el.id === 'smr-all') return;
      var v = (el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  function setURLParamList(param, values){
    try{
      var u = new URL(window.location.href);
      // remove all existing occurrences (handles duplicates/comma cases neatly)
      while (u.searchParams.has(param)) u.searchParams.delete(param);
      // re-add from UI
      (values || []).forEach(function(v){ u.searchParams.append(param, v); });
      history.replaceState(null, '', u.toString());
    }catch(_){}
  }

  // --- Helper: read/write "all footwear" URL flag ---
  function isAllFootwearParamOn(){
    try { return new URL(window.location.href).searchParams.get('fw_all') === '1'; }
    catch(_){ return false; }
  }
  function setAllFootwearParam(on){
    try{
      var u = new URL(window.location.href);
      if (on) u.searchParams.set('fw_all', '1');
      else    u.searchParams.delete('fw_all');
      history.replaceState(null, '', u.toString()); // no reload
    }catch(_){}
  }


  /**
   * Loops PARAM_TO_INPUT_NAME and mirrors current UI selections to the URL.
   * If a mapped group has no checks, the URL param is removed.
   */
  function syncMappedParamsToURL(){
    if (__bulkClearing) return; // don't mutate URL while we're mass-applying state
    Object.keys(PARAM_TO_INPUT_NAME).forEach(function(param){
      var inputName = PARAM_TO_INPUT_NAME[param];
      // only sync params that actually exist in this DOM
      if (document.querySelector('input[name="'+inputName+'"]')){
        var vals = getCheckedValuesByName(inputName);
        setURLParamList(param, vals);
      }
    });
  }

  // --- NEW: clear price params + reset slider UI (labels + fill) ---
  function clearPriceFromURLAndResetSliderUI(){
    try{
      var u = new URL(window.location.href);
      u.searchParams.delete('filter.v.price.gte');
      u.searchParams.delete('filter.v.price.lte');
      history.replaceState(null, '', u.toString());
    }catch(_){}

    // Reset the visible slider to full current bounds
    var minR  = document.getElementById('minRange');
    var maxR  = document.getElementById('maxRange');
    var minVal= document.getElementById('minVal');
    var maxVal= document.getElementById('maxVal');
    var fill  = document.getElementById('rangeFill');
    if (!minR || !maxR) return;

    var minBound = Number(minR.min || 0);
    var maxBound = Number(maxR.max || maxR.value || 0);

    minR.value = String(minBound);
    maxR.value = String(maxBound);

    if (minVal) minVal.textContent = String(minBound);
    if (maxVal) maxVal.textContent = String(maxBound);

    if (fill){
      var denom = (maxBound - minBound) || 1;
      var leftPct  = ((Number(minR.value) - minBound) / denom) * 100;
      var rightPct = ((Number(maxR.value) - minBound) / denom) * 100;
      fill.style.left  = leftPct + '%';
      fill.style.width = (rightPct - leftPct) + '%';
    }
  }

  // --- NEW: clear ALL filter-related params (including sort_by) from URL ---
  function clearAllFilterParamsFromURL(){
    try{
      var u = new URL(window.location.href);

      // Price
      u.searchParams.delete('filter.v.price.gte');
      u.searchParams.delete('filter.v.price.lte');

      // Mapped metafields (& any we may add in the future via URL_META_MAP)
      Object.keys(URL_META_MAP || {}).forEach(function(param){
        while (u.searchParams.has(param)) u.searchParams.delete(param);
      });

      // Any params we mirror via PARAM_TO_INPUT_NAME (brand, clothing-type, footwear-size, etc.)
      Object.keys(PARAM_TO_INPUT_NAME || {}).forEach(function(param){
        while (u.searchParams.has(param)) u.searchParams.delete(param);
      });

      // Sort as well (requested: clear ALL params)
      u.searchParams.delete('sort_by');

      history.replaceState(null, '', u.toString());
    }catch(_){}
  }




  function setCollapseOpen(collapseId){
    var el = document.getElementById(collapseId);
    if (!el) return;
    el.classList.add('show');
    // flip the matching header button too
    var btn = document.querySelector('[data-bs-target="#' + collapseId + '"]');
    if (btn){
      btn.classList.remove('collapsed');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  function applyPriceFromURL(){
    var params = getURLParams();
    var gte = params.get('filter.v.price.gte');
    var lte = params.get('filter.v.price.lte');

    var minR = document.getElementById('minRange');
    var maxR = document.getElementById('maxRange');
    var minVal = document.getElementById('minVal');
    var maxVal = document.getElementById('maxVal');
    var fill = document.getElementById('rangeFill');

    if (!minR || !maxR) return;

    if (gte != null && !isNaN(parseFloat(gte))) minR.value = String(parseFloat(gte));
    if (lte != null && !isNaN(parseFloat(lte))) maxR.value = String(parseFloat(lte));

    if (minVal) minVal.textContent = String(minR.value);
    if (maxVal) maxVal.textContent = String(maxR.value);

    // repaint the range fill
    var minBound = Number(minR.min || 0);
    var maxBound = Number(maxR.max || maxR.value || 0);
    var denom = (maxBound - minBound) || 1;
    var leftPct  = ((Number(minR.value) - minBound) / denom) * 100;
    var rightPct = ((Number(maxR.value) - minBound) / denom) * 100;
    if (fill){
      fill.style.left  = leftPct + '%';
      fill.style.width = (rightPct - leftPct) + '%';
    }

    // ✅ ADD THIS BELOW: Sync the sidebar search with ?q=
    try {
      var qFromURL = new URL(window.location.href).searchParams.get('q');
      if (qFromURL && qFromURL.trim() !== '') {
        var leftKW = document.getElementById('keyword-search-input');
        if (leftKW) {
          leftKW.value = qFromURL.trim(); // Fill the sidebar input visually
        }
        if (typeof __keyword !== 'undefined') {
          __keyword = qFromURL.trim(); // Sync internal keyword variable
        }
      }
    } catch (_) {}
  }

  function mapURLActivityToUIValue(v) {
    var s = String(v || '').trim().toLowerCase();

    // Only this special rule:
    // activity=Racing  → tick the "Speed" checkbox
    if (s === 'racing') return 'Speed';

    // Default: use the same label
    return v;
  }

  function expandAccordionById(collapseId){
    var el = document.getElementById(collapseId);
    if (!el) return;

    // If bootstrap collapse is available, use it
    try {
      if (window.bootstrap && bootstrap.Collapse) {
        var inst = bootstrap.Collapse.getOrCreateInstance(el, { toggle: false });
        inst.show();
        return;
      }
    } catch (_) {}

    // Fallback: force "show" class (in case bootstrap not accessible here)
    try {
      el.classList.add('show');
    } catch (_) {}
  }


  // --- URL → UI sync (pre-check boxes, open accordions, set price + gender from path) ---
  function applyURLParamsToUI(){
    // prevent change handlers from firing while we set initial state
    __bulkClearing = true;

    // 1) Check boxes for each mapped param
    Object.keys(PARAM_TO_INPUT_NAME).forEach(function(param){
      var inputName = PARAM_TO_INPUT_NAME[param];
      var values = getURLMultiValues(param); // handles repeated & comma-separated
      if (!values.length) return;

      values.forEach(function(v){
        var sel = 'input[name="' + inputName + '"][value="' + v.replace(/"/g,'\\"') + '"]';
        var el = document.querySelector(sel);
        if (el) el.checked = true;
      });
    });

    // 2) Price range from URL (if present)
    applyPriceFromURL();

    // 2.5) NEW: Pre-select gender from the current collection handle in the PATH
    // e.g. /collections/mens-footwear-1 → check Men's under Footwear
    (function preselectGenderFromPath(){
      var pathHandle = null;
      try {
        var u = new URL(window.location.href);
        var parts = u.pathname.split('/').filter(Boolean);
        pathHandle = (parts[0] === 'collections' && parts[1]) ? parts[1] : null;
      } catch(_){ /* ignore */ }

      if (!pathHandle) return;

      // Helper: apply "radio-like" behavior and check the target id
      function checkGenderForCategory(key, targetId){
        var def = CATEGORY_DEFS[key];
        if (!def || !def.genderName || !targetId) return;
        // Uncheck all in the group then check the target
        document.querySelectorAll('input[name="' + def.genderName + '"]').forEach(function(el){
          el.checked = false;
        });
        var target = document.getElementById(targetId);
        if (target) target.checked = true;
      }

      // Footwear: match path handle to men/women map
      (function(){
        var def = CATEGORY_DEFS.footwear;
        if (!def || !def.handlesByGender || !def.genderIds) return;
        if (pathHandle === def.handlesByGender.men)   checkGenderForCategory('footwear', def.genderIds.men);
        if (pathHandle === def.handlesByGender.women) checkGenderForCategory('footwear', def.genderIds.women);
      })();

      // Clothing: match path handle to men/women map
      (function(){
        var def = CATEGORY_DEFS.clothing;
        if (!def || !def.handlesByGender || !def.genderIds) return;
        if (pathHandle === def.handlesByGender.men)   checkGenderForCategory('clothing', def.genderIds.men);
        if (pathHandle === def.handlesByGender.women) checkGenderForCategory('clothing', def.genderIds.women);
      })();
    })();

    // 3) Open accordions that have something checked
    var anyFootwear =
      document.querySelector('input[name="footwear_gender[]"]:checked') ||
      document.querySelector('input[name="footwear_size[]"]:checked')   ||
      document.querySelector('input[name="footwear_feel[]"]:checked')   ||
      document.querySelector('input[name="footwear_activity[]"]:checked')||
      document.querySelector('input[name="footwear_injury[]"]:checked') ||
      document.querySelector('input[name="footwear_width[]"]:checked'); // ✅ add


    if (anyFootwear){
      // Open main "Category"
      setCollapseOpen('collapseCategory');
      // Open "Footwear"
      setCollapseOpen('collapseFootwear');

      // Open specific inner groups if they have checks
      if (document.querySelector('input[name="footwear_feel[]"]:checked'))      setCollapseOpen('collapseFootwearFeel');
      if (document.querySelector('input[name="footwear_activity[]"]:checked'))  setCollapseOpen('collapseFootwearActivity');
      if (document.querySelector('input[name="footwear_injury[]"]:checked'))    setCollapseOpen('collapseFootwearInjury');
      if (document.querySelector('input[name="footwear_size[]"]:checked'))      setCollapseOpen('collapseFootwearSize');
      if (document.querySelector('input[name="footwear_gender[]"]:checked'))    setCollapseOpen('collapseFootwearGender');
      if (document.querySelector('input[name="footwear_width[]"]:checked'))     setCollapseOpen('collapseFootwearWidth'); // ✅ add
    }

    // 4) Make sure the "All Footwear" master looks correct (unchecked when children are checked)
    syncMasterWithChildren('footwear');

    // --- Clothing: Open accordions if clothing params or gender were pre-checked ---
    var anyClothing =
      document.querySelector('input[name="clothing_gender[]"]:checked') ||
      document.querySelector('input[name="clothing_type[]"]:checked')   ||
      document.querySelector('input[name="clothing_size[]"]:checked');

    if (anyClothing){
      setCollapseOpen('collapseCategory');
      setCollapseOpen('collapseClothing');

      if (document.querySelector('input[name="clothing_type[]"]:checked'))  setCollapseOpen('collapseClothingType');
      if (document.querySelector('input[name="clothing_size[]"]:checked'))  setCollapseOpen('collapseClothingSize');
      if (document.querySelector('input[name="clothing_gender[]"]:checked')) setCollapseOpen('collapseClothingGender');
    }

    // Keep Clothing master visually correct too
    syncMasterWithChildren('clothing');

    // --- Brands: open if any brand pre-checked ---
    if (document.querySelector('input[name="brands[]"]:checked')) {
      setCollapseOpen('collapseBrands');
    }

    __bulkClearing = false;
// --- Activity (from URL) with Racing -> Speed mapping ---
(function applyActivityFromURL(){
  // uses your existing URL parser (already handles repeated & comma-separated)
  var vals = getURLMultiValues('activity');
  if (!vals || !vals.length) return;

  // Map special values from URL to UI checkbox values
  var mapped = vals.map(mapURLActivityToUIValue).filter(Boolean);
  if (!mapped.length) return;

  // Case-insensitive lookup
  var want = {};
  mapped.forEach(function(v){
    want[String(v).trim().toLowerCase()] = true;
  });

  // Tick matching checkboxes by comparing their VALUE attribute
  document.querySelectorAll('input[name="footwear_activity[]"]').forEach(function(el){
    var ev = String(el.value || '').trim().toLowerCase();
    if (want[ev]) el.checked = true;
  });

  
})();


  }



  // Map Shopify-style sort_by param to ProductCollectionSortKeys + reverse
  function getSortFromURL() {
    var params = getURLParams();
    var s = params.get('sort_by');
    // Common Shopify values; add others if you use them
    switch (s) {
      case 'best-selling':       return { sortKey: 'BEST_SELLING', reverse: false };
      case 'price-ascending':    return { sortKey: 'PRICE',        reverse: false };
      case 'price-descending':   return { sortKey: 'PRICE',        reverse: true  };
      case 'created-descending': return { sortKey: 'CREATED',      reverse: true  };
      case 'created-ascending':  return { sortKey: 'CREATED',      reverse: false };
      case 'title-ascending':    return { sortKey: 'TITLE',        reverse: false };
      case 'title-descending':   return { sortKey: 'TITLE',        reverse: true  };
      case 'manual':             return { sortKey: 'MANUAL',       reverse: false };
      default:                   return null; // Use collection default
    }
  }

  // Build filters from URL: price range + any mapped metafield params
  function buildFiltersFromURL() {
    var params = getURLParams();
    var filters = [];

    // -------------------------
    // ✅ PRICE FILTER (from URL)
    // -------------------------
    // Shopify Storefront ProductFilter supports:
    // { price: { min: Float, max: Float } }
    var priceMinRaw = params.get('filter.v.price.gte');
    var priceMaxRaw = params.get('filter.v.price.lte');

    var priceMin = (priceMinRaw != null && priceMinRaw !== '' && !isNaN(parseFloat(priceMinRaw)))
      ? parseFloat(priceMinRaw)
      : null;

    var priceMax = (priceMaxRaw != null && priceMaxRaw !== '' && !isNaN(parseFloat(priceMaxRaw)))
      ? parseFloat(priceMaxRaw)
      : null;

    if (priceMin != null || priceMax != null) {
      var priceObj = {};
      if (priceMin != null) priceObj.min = priceMin;
      if (priceMax != null) priceObj.max = priceMax;
      filters.push({ price: priceObj });
    }

    // -------------------------
    // Existing metafield param mapping
    // -------------------------
    if (typeof URL_META_MAP !== 'object' || !URL_META_MAP) return filters;

    Object.keys(URL_META_MAP).forEach(function (param) {
      // If param isn't in the URL, skip (important!)
      if (!params.has(param)) return;

      var meta = URL_META_MAP[param];

      // Collect values (supports multi-select params too)
      var vals = [];
      try {
        vals = params.getAll(param) || [];
      } catch (_) {
        var single = params.get(param);
        vals = single != null ? [single] : [];
      }

      vals = vals
        .map(function (v) { return (v == null ? '' : String(v)).trim(); })
        .filter(function (v) { return v !== ''; });

      if (!vals.length) return;

      // ✅ support object metas (like {namespace,key}) — ignore other object shapes safely
      if (meta && typeof meta === 'object') {
        // If you used this style: { namespace:'custom', key:'online_width' }
        if (meta.namespace && meta.key) {
          vals.forEach(function (v) {
            filters.push({
              productMetafield: {
                namespace: String(meta.namespace),
                key: String(meta.key),
                value: v
              }
            });
          });
        }
        return; // important: don't fall into string logic
      }

      // Existing behavior expects string
      if (typeof meta !== 'string') return;

      // product vendor
      if (meta === 'vendor' || meta === 'productVendor') {
        vals.forEach(function (v) {
          filters.push({ productVendor: v });
        });
        return;
      }

      // product type
      if (meta === 'type' || meta === 'productType') {
        vals.forEach(function (v) {
          filters.push({ productType: v });
        });
        return;
      }

      // variant option: "variantOption:Size"
      if (meta.indexOf('variantOption:') === 0) {
        var optName = meta.slice('variantOption:'.length);
        vals.forEach(function (v) {
          filters.push({ variantOption: { name: optName, value: v } });
        });
        return;
      }

      // metafield "namespace.key"
      if (meta.indexOf('.') !== -1) {
        var parts = meta.split('.');
        var ns = parts[0];
        var key = parts.slice(1).join('.');
        vals.forEach(function (v) {
          filters.push({ productMetafield: { namespace: ns, key: key, value: v } });
        });
        return;
      }

      // If it reaches here, it's an unrecognized string mapping: ignore safely
    });

    return filters;
  }


    // --------- UI helpers (checkbox groups) ---------
  // Collect metafield filters from all groups on the page
  function buildFiltersFromGroups() {
    var groups = Array.prototype.slice.call(document.querySelectorAll('#sf-metafield-filters .sf-group'));
    var all = [];
    groups.forEach(function (group) {
      var ns  = group.getAttribute('data-metafield-namespace');
      var key = group.getAttribute('data-metafield-key');
      if (!ns || !key) return;
      var checks = group.querySelectorAll('input[type="checkbox"]:checked');
      Array.prototype.forEach.call(checks, function (c) {
        var v = (c.value || '').trim();
        if (!v) return;
        all.push({ productMetafield: { namespace: ns, key: key, value: v } });
      });
    });
    return all;
  }

  function buildFiltersFromCheckboxMap() {
    var out = [];
    Object.keys(CHECKBOX_MAP).forEach(function(id){
      var el = document.getElementById(id);
      if (!el || !el.checked) return;

      var cfg = CHECKBOX_MAP[id];

      if (cfg.kind === 'tag') {
        var tagVal = (el.value || '').trim();
        if (tagVal) out.push({ tag: tagVal });
        return;
      }

      if (cfg.kind === 'productType') {
        var ptVal = (el.value || '').trim();
        if (ptVal) out.push({ productType: ptVal });
        return;
      }

      if (cfg.kind === 'productMetafield') {
        // If you ever need this from a checkbox, you can store ns/key in cfg and value in el.value
        var v = (el.value || '').trim();
        if (!v) return;
        out.push({
          productMetafield: {
            namespace: cfg.namespace,
            key:       cfg.key,
            value:     v
          }
        });
        return;
      }
    });
    return out;
  }

  function buildFiltersFromFootwearGroups() {
    var out = [];

    Object.keys(FOOTWEAR_GROUP_META_MAP).forEach(function(nameAttr){
      var meta = FOOTWEAR_GROUP_META_MAP[nameAttr];
      var inputs = document.querySelectorAll('input[name="' + nameAttr + '"]:checked');

      inputs.forEach(function(input){
        var v = (input.value || '').trim();
        if (!v) return;
        out.push({
          productMetafield: {
            namespace: meta.namespace,
            key:       meta.key,
            value:     v
          }
        });
      });
    });

    return out;
  }

  function getSelectedSizes() {
    var inputs = document.querySelectorAll('input[name="' + FOOTWEAR_SIZE_INPUT_NAME + '"]:checked');
    var sizes = [];
    inputs.forEach(function (el) {
      var v = (el.value || '').trim();
      if (v) sizes.push(v);
    });
    return sizes;
  }



  function getCollectionHandleForQuery(defaultHandle) {
    // If the "Sale only" toggle is ON, always query the real Sale collection
    // if (saleOnlySelected()) return SALE_COLLECTION_HANDLE;

    var order = ['footwear', 'clothing', 'accessories', 'smr'];

    // Read current path handle
    var pathHandle = (function(){
      try {
        var u = new URL(window.location.href);
        var parts = u.pathname.split('/').filter(Boolean);
        return (parts[0] === 'collections' && parts[1]) ? parts[1] : null;
      } catch(_){ return null; }
    })();

    // IMPORTANT: Do NOT auto-restore from /sale here.
    // If the current path is /collections/sale and the sale toggle is OFF,
    // just keep using the current path unless user explicitly unchecks the box
    // (the uncheck handler will do the restore).
    if (pathHandle === SALE_COLLECTION_HANDLE) {
      return SALE_COLLECTION_HANDLE;
    }

    for (var i = 0; i < order.length; i++) {
      var key = order[i];
      if (!isCategoryActive(key)) continue;

      var def = CATEGORY_DEFS[key];
      var g = getGenderForCategory(key);

      // If gender explicitly selected and a gendered handle exists → use it
      if (def && def.handlesByGender && g && def.handlesByGender[g]) {
        return def.handlesByGender[g];
      }

      // If gender not selected, but current path belongs to this category → keep it
      if ((key === 'footwear' || key === 'clothing') && def && def.handlesByGender) {
        var known = Object.values(def.handlesByGender || {});
        if (pathHandle && known.indexOf(pathHandle) !== -1) {
          return pathHandle;
        }
      }

      // Fallback to the category’s default handle
      if (def && def.handle) return def.handle;
    }

    // If nothing active, keep the current path’s handle, else default
    return pathHandle || defaultHandle;
  }






  // Fetch the highest price (as a number) for a given handle; for "all" use root
  function fetchMaxPriceForCollection(handle){
    // Special-case: /collections/all → use root products
    if (handle === ALL_PRODUCTS_HANDLE) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SF_TOKEN
        },
        body: JSON.stringify({ query: QUERY_MAX_PRICE_ALL, variables: {} })
      })
      .then(function(res){ if(!res.ok) throw new Error('Storefront API ' + res.status); return res.json(); })
      .then(function(json){
        if (json.errors) throw new Error('GraphQL errors');
        var nodes = json?.data?.products?.nodes || [];
        if (!nodes.length) return null;
        var price = nodes[0]?.priceRange?.maxVariantPrice?.amount;
        var n = parseFloat(price);
        return isFinite(n) ? n : null;
      }).catch(function(){ return null; });
    }

    // Default: collection-based
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SF_TOKEN
      },
      body: JSON.stringify({ query: QUERY_MAX_PRICE, variables: { handle: handle } })
    })
    .then(function(res){ if(!res.ok) throw new Error('Storefront API ' + res.status); return res.json(); })
    .then(function(json){
      if (json.errors) throw new Error('GraphQL errors');
      var nodes = json?.data?.collection?.products?.nodes || [];
      if (!nodes.length) return null;
      var price = nodes[0]?.priceRange?.maxVariantPrice?.amount;
      var n = parseFloat(price);
      return isFinite(n) ? n : null;
    }).catch(function(){ return null; });
  }


  // Cache last handle so we only refetch when the collection changes
  var __lastSliderHandle = null;

  // Set <input type="range"> max to the real highest price, clamp values, repaint bar
  function ensureSliderMaxForHandle(handle){
    var minR = document.getElementById('minRange');
    var maxR = document.getElementById('maxRange');
    var minVal = document.getElementById('minVal');
    var maxVal = document.getElementById('maxVal');
    var fill = document.getElementById('rangeFill');

    if (!minR || !maxR) return Promise.resolve();       // no slider in DOM

    if (__lastSliderHandle === handle) return Promise.resolve(); // already synced
    __lastSliderHandle = handle;

    return fetchMaxPriceForCollection(handle).then(function(maxAmount){
      if (maxAmount == null) return;

      var ceilMax = Math.ceil(maxAmount); // integer steps (e.g., 999.95 -> 1000)

      // Apply to both sliders
      minR.max = String(ceilMax);
      maxR.max = String(ceilMax);

      // Clamp current values inside new bound
      if (Number(maxR.value) > ceilMax) maxR.value = String(ceilMax);
      if (Number(minR.value) > Number(maxR.value)) minR.value = maxR.value;

      // Update labels + bar
      if (minVal) minVal.textContent = String(minR.value);
      if (maxVal) maxVal.textContent = String(maxR.value);

      // Recompute the fill using current values against new bounds
      var minBound = Number(minR.min || 0);
      var leftPct  = ((Number(minR.value) - minBound) / (ceilMax - minBound)) * 100;
      var rightPct = ((Number(maxR.value) - minBound) / (ceilMax - minBound)) * 100;
      if (fill){
        fill.style.left  = leftPct + '%';
        fill.style.width = (rightPct - leftPct) + '%';
      }
    }).catch(function(){ /* ignore — slider stays as-is */ });
  }

  // ----- BRANDS (Vendor) -----
  var BRAND_INPUT_NAME = 'brands[]';

  function getSelectedBrands() {
    var inputs = document.querySelectorAll('input[name="' + BRAND_INPUT_NAME + '"]:checked');
    var set = {};
    inputs.forEach(function (el) {
      var v = (el.value || '').trim();
      if (!v) return;
      set[v] = true; // keep original vendor casing from Admin
    });
    return Object.keys(set);
  }



  // Merge URL filters + UI filters, avoiding duplicates
  function mergedFilters() {
    // If we're on /collections/all and user hasn't picked anything,
    // we STILL want to restrict to in-stock only.
    if (isOnCollectionHandle(ALL_PRODUCTS_HANDLE) && !anyUIOrURLFilterActive()){
      return [{ available: true }];
    }

    var fromURL      = buildFiltersFromURL();            // price + URL metafields
    var fromGroups   = buildFiltersFromGroups();         // legacy metafield groups
    var fromIDs      = buildFiltersFromCheckboxMap();    // tag/collection/etc
    var fromFootwear = buildFiltersFromFootwearGroups(); // feel/activity/injury
    var sizesSelected  = getSelectedSizes ? getSelectedSizes() : [];
    var brandsSelected = getSelectedBrands ? getSelectedBrands() : [];

    var seen = {};
    var out  = [];

    // include price from URL (only one expected)
    fromURL.forEach(function (f) { if (f && f.price) out.push(f); });

    function pushMetaDedup(f) {
      if (!f || !f.productMetafield) return false;
      var mk = f.productMetafield.namespace + '|' + f.productMetafield.key + '|' + f.productMetafield.value;
      if (!seen[mk]) { seen[mk] = true; out.push(f); }
      return true;
    }

    // URL metafields first
    fromURL.forEach(function(f){
      if (!f) return;
      if (!pushMetaDedup(f) && !f.price) out.push(f);
    });

    // Footwear Feel/Activity/Injury
    fromFootwear.forEach(pushMetaDedup);

    // Sidebar mapped checkboxes (tag/collection/metafield etc.)
    fromIDs.forEach(function(f){ if (!pushMetaDedup(f)) out.push(f); });

    // Any legacy group-based metafields
    fromGroups.forEach(pushMetaDedup);

    // ---- SINGLE Size (variant option) ----
    if (sizesSelected.length === 1) {
      out.push({ variantOption: { name: FOOTWEAR_SIZE_NAME, value: sizesSelected[0] } });
    }

    // ---- SINGLE Brand (productVendor) ----
    if (brandsSelected.length === 1) {
      out.push({ productVendor: brandsSelected[0] }); // Storefront API expects productVendor
    }

    // ---- ACCESSORIES: parent + (single) child ----
    (function(){
      var allAcc = document.getElementById('acc-all');
      var types  = getSelectedAccessoryTypes();

      // Parent gate if master checked OR any child selected
      if ((allAcc && allAcc.checked) || types.length) {
        out.push({ productMetafield: { namespace: ACCESSORY_PARENT_META.namespace, key: ACCESSORY_PARENT_META.key, value: ACCESSORY_PARENT_META.value } });
      }

      // If exactly one accessory child type is selected, add it here
      if (types.length === 1) {
        out.push({ productMetafield: { namespace: ACCESSORY_CHILD_META_KEY.namespace, key: ACCESSORY_CHILD_META_KEY.key, value: types[0] } });
      }
    })();

    // ---- SPORTS MEDICINE & RECOVERY: parent + (single) child ----
    (function(){
      var smrAll = document.getElementById('smr-all');
      var types  = getSelectedSmrTypes();

      if ((smrAll && smrAll.checked) || types.length) {
        out.push({
          productMetafield: {
            namespace: SMR_PARENT_META.namespace,
            key:       SMR_PARENT_META.key,
            value:     SMR_PARENT_META.value
          }
        });
      }

      if (types.length === 1) {
        out.push({
          productMetafield: {
            namespace: SMR_CHILD_META_KEY.namespace,
            key:       SMR_CHILD_META_KEY.key,
            value:     types[0]
          }
        });
      }
    })();

    // ---- CLOTHING: Type (productType) + single Size (variant option) ----
    (function(){
      var clothingTypes = getSelectedClothingTypes();
      var clothingSizes = getSelectedClothingSizes();

      if (clothingTypes.length === 1) {
        out.push({ productType: clothingTypes[0] });
      }

      if (clothingSizes.length === 1) {
        out.push({ variantOption: { name: CLOTHING_SIZE_OPTION_NAME, value: clothingSizes[0] } });
      }
    })();

    // --- IMPORTANT: remove "activity" metafield from server filters (we'll do client-side includes)
    out = out.filter(function (f) {
      if (!f || !f.productMetafield) return true;
      var pm = f.productMetafield;
      return !(pm.namespace === 'custom' && pm.key === 'online_feel_child_2');
    });

    // === ALWAYS require in-stock products on the server ===
    var hasAvail = out.some(function(f){ return f && f.available === true; });
    if (!hasAvail) out.push({ available: true });

    return out;
  }






  // --------- Rendering helpers ---------
  function money(amount, currency) {
    var n = Number(amount || 0);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(n); }
    catch(e) { return n.toFixed(2) + ' ' + (currency || ''); }
  }

  // === real sale only if compare_at > price ===
  // Unify sale detection: use variant-level check everywhere
  function isProductTrulyOnSale(p){
    return isProductDiscounted(p);
  }




  // --- Build gallery: one image per unique variant (usually per color), then other images
  function buildVariantFirstImages(p){
    var ordered = [];
    var seenUrl = Object.create(null);

    function push(img){
      if (!img || !img.url) return;
      var url = String(img.url);
      if (seenUrl[url]) return;
      seenUrl[url] = true;
      ordered.push({ url: url, altText: img.altText || p.title || '' });
    }

    // Try to pick one image per unique "color-like" option value
    var colorHints = ['color', 'Color', 'colour', 'colorway', 'colourway', 'shade', 'hue'];

    if (p && p.variants && p.variants.nodes && p.variants.nodes.length){
      var usedVariantKey = Object.create(null);

      p.variants.nodes.forEach(function(v){
        if (!v || !v.image || !v.image.url) return;

        var so = v.selectedOptions || [];
        var key = null;

        for (var i = 0; i < so.length; i++){
          var name = String(so[i].name || '').toLowerCase();
          if (colorHints.some(function(h){ return name.indexOf(h) !== -1; })){
            key = ('opt:' + String(so[i].value || '').toLowerCase());
            break;
          }
        }

        // If no explicit color option, dedupe by the variant image URL
        if (!key) key = 'img:' + String(v.image.url).toLowerCase();

        if (!usedVariantKey[key]){
          usedVariantKey[key] = true;
          push(v.image);
        }
      });
    }

    // Then append remaining product images (deduped)
    var imgs = (p && p.images && p.images.nodes) || [];
    imgs.forEach(push);

    // Fallback placeholder
    if (!ordered.length){
      ordered.push({ url: '/cdn/shop/files/placeholder-image-1.jpg', altText: 'Placeholder Image' });
    }
    return ordered;
  }

  // Choose prices to display on the card.
  // Prefers the CHEAPEST discounted variant (compare_at > price).
  // Fallback to product-level min ranges if variants are missing.
  function computeDisplayPricing(p){
    var best = null;

    // Try variant-level first (most accurate)
    if (p && p.variants && p.variants.nodes && p.variants.nodes.length){
      for (var i = 0; i < p.variants.nodes.length; i++){
        var v = p.variants.nodes[i];
        var price = parseFloat(v && v.price && v.price.amount);
        var cmp   = parseFloat(v && v.compareAtPrice && v.compareAtPrice.amount);
        var cur   = (v && v.price && v.price.currencyCode) || (v && v.compareAtPrice && v.compareAtPrice.currencyCode) || (p && p.priceRange && p.priceRange.minVariantPrice && p.priceRange.minVariantPrice.currencyCode) || 'USD';

        if (isFinite(price) && isFinite(cmp) && cmp > price){
          if (!best || price < best.price){
            best = { price: price, compareAt: cmp, currency: cur, onSale:true };
          }
        }
      }
    }

    if (best) return best;

    // Fallback to product-level min price + min compare_at
    var pr  = p && p.priceRange && p.priceRange.minVariantPrice;
    var cpr = p && p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice;
    var priceMin = pr && isFinite(parseFloat(pr.amount)) ? parseFloat(pr.amount) : null;
    var cmpMin   = cpr && isFinite(parseFloat(cpr.amount)) ? parseFloat(cpr.amount) : null;
    var curProd  = (pr && pr.currencyCode) || (cpr && cpr.currencyCode) || 'USD';

    if (priceMin != null && cmpMin != null && cmpMin > priceMin) {
      return { price: priceMin, compareAt: cmpMin, currency: curProd, onSale:true };
    }

    // Final fallback: just the min price
    return { price: priceMin != null ? priceMin : 0, compareAt:null, currency: curProd, onSale:false };
  }

  // Ask Shopify CDN for a smaller variant (falls back to _{w}x pattern)
  function sized(imgUrl, w){
    if (!imgUrl) return '';
    try{
      var u = new URL(imgUrl);
      u.searchParams.set('width', String(w));   // modern CDN param
      return u.toString();
    }catch(_){
      // fallback for older URLs
      return String(imgUrl).replace(/(\.(?:jpe?g|png|webp|gif))(?:\?.*)?$/i, '_' + w + 'x$1');
    }
  }


  function productCardHTML(p) {
    // Use your variant-first ordering: one image per color first, then the rest
    var imgs = buildVariantFirstImages(p);

    

    // Choose sensible sizes for speed (tune these if your card changes):
    var MAIN_W  = 600;  // main slide image
    var THUMB_W = 140;  // bottom thumbnail

    // Main slides
    var mainSlides = imgs.map(function(img){
      var src = sized(img.url, MAIN_W);
      return '' +
        '<a href="/products/' + p.handle + '" class="img-outer d-flex justify-content-center">' +
          '<img ' +
            'src="' + src + '" ' +
            'alt="' + (img.altText || p.title) + '" ' +
            'loading="lazy" decoding="async" width="' + MAIN_W + '" height="' + MAIN_W + '"' +
          '>' +
        '</a>';
    }).join('');

    // Thumbs
    var thumbSlides = imgs.map(function(img){
      var src = sized(img.url, THUMB_W);
      return '' +
        '<div class="nav-box"><div class="nav-box-inner">' +
          '<img ' +
            'src="' + src + '" ' +
            'alt="' + (img.altText || p.title) + '" ' +
            'loading="lazy" decoding="async" width="' + THUMB_W + '" height="' + THUMB_W + '"' +
          '>' +
        '</div></div>';
    }).join('');

    var compare = p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice ? p.compareAtPriceRange.minVariantPrice : null;
    var price   = p.priceRange && p.priceRange.minVariantPrice ? p.priceRange.minVariantPrice : null;

    var isRealSale = isProductTrulyOnSale(p);

    var priceHTML = '';
    if (price) {
      if (isRealSale) {
        priceHTML =
          '<span class="txt--light-blue original price price--compare"><b>' +
            money(compare.amount, compare.currencyCode) +
          '</b></span>' +
          '<span class="txt--light-blue price--current"><b>' +
            money(price.amount, price.currencyCode) +
          '</b></span>';
      } else {
        priceHTML =
          '<span class="txt--light-blue price--current"><b>' +
            money(price.amount, price.currencyCode) +
          '</b></span>';
      }
    }

    var saleLabelHTML = isRealSale
      ? '<div class="sale-label"><span class="txt--dark-blue">Sale!</span></div>'
      : '';

    return '' +
      '<div class="box product-card">' +
        '<div class="rectangle">' +
          '<div class="img-box">' +
            '<div class="slider-for">' + mainSlides + '</div>' +
            saleLabelHTML +
          '</div>' +
          '<div class="content-box">' +
            '<h4>' +
              '<a href="/products/' + p.handle + '" class="txt--dark-blue text-uppercase">' + p.title + '</a>' +
            '</h4>' +
            '<div class="price-wrapper d-flex align-items-center">' + priceHTML + '</div>' +
          '</div>' +
          '<div class="slider-nav-box">' +
            '<div class="slider-nav">' + thumbSlides + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }







  function initSlickFor(containerEl) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
      console.warn('[Filters] Slick not found. Make sure Slick JS/CSS are loaded.');
      return;
    }
    var $ = window.jQuery;

    $(containerEl).find('.box').each(function(){
      var $box = $(this);
      if ($box.data('slick-ready')) return; // don't double init

      inViewportOnce(this, function(){
        rIC(function(){
          if ($box.data('slick-ready')) return;

          var $sliderFor = $box.find('.slider-for');
          var $sliderNav = $box.find('.slider-nav');

          $sliderFor.slick({
            slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true, asNavFor: $sliderNav
          });
          $sliderNav.slick({
            slidesToShow: 3, slidesToScroll: 1, asNavFor: $sliderFor, dots: false, centerMode: false, focusOnSelect: true
          });

          $box.data('slick-ready', true);
        });
      });
    });
  }

  function updateResultsBadge(n){
    var el = document.getElementById('no-of-results');
    if (!el) return;

    // Show the badge and write the count
    el.classList.remove('d-none');
    el.textContent = n + ' result' + (n === 1 ? '' : 's');
  }


  function setCount(n) {
    if (countEl) {
      countEl.textContent = n ? ('Showing ' + n + ' product' + (n === 1 ? '' : 's'))
                              : 'No products found';
    }
    updateResultsBadge(n);   // <— keeps the <span id="no-of-results"> in sync
  }


  function renderProducts(products, append) {
    var CHUNK = 6; // render 8 cards at a time
    var wrapper = resultsEl.querySelector('.boxes-wrapper');

    if (!products || !products.length) {
      if (!append) resultsEl.innerHTML = '<h3 class="txt--dark-blue no-products-found-message">No products found for selected filters.</h3>';
      return;
    }

    if (!append || !wrapper) {
      resultsEl.innerHTML = '<div class="boxes-wrapper d-flex flex-wrap"></div>';
      wrapper = resultsEl.querySelector('.boxes-wrapper');
    }

    // chunked append + lazy slick init
    var i = 0;
    (function pump(){
      var slice = products.slice(i, i + CHUNK);
      if (!slice.length) return;

      // build HTML once per chunk
      var html = slice.map(productCardHTML).join('');
      wrapper.insertAdjacentHTML('beforeend', html);

      // init sliders lazily for new DOM
      initSlickFor(wrapper);

      i += CHUNK;
      rIC(pump); // schedule the next chunk off the critical path
    })();
  }


  // Returns true if product p has an in-stock variant matching sizeValue on optionName (e.g. "Size")
  function productHasAvailableSize(p, optionName, sizeValue) {
    if (!p || !p.variants || !p.variants.nodes) return false;
    var optsName = String(optionName || 'Size').toLowerCase();
    var size = String(sizeValue || '').trim();
    if (!size) return false;

    return p.variants.nodes.some(function(v){
      if (!v || !v.availableForSale) return false; // must be in stock
      var so = v.selectedOptions || [];
      return so.some(function(o){
        return (String(o.name || '').toLowerCase() === optsName) && (String(o.value || '') === size);
      });
    });
  }

  // Which option name should we check for the active category (footwear vs clothing)?
  function getActiveSizeOptionName() {
    // both of your size option names are "Size", but keep this flexible:
    if (isCategoryActive('clothing')) return CLOTHING_SIZE_OPTION_NAME; // "Size"
    if (isCategoryActive('footwear')) return FOOTWEAR_SIZE_NAME;        // "Size"
    return 'Size';
  }

  // --- NEW: sale-only helpers (true sale = compare_at > price) ---
  function isProductOnSale(p) {
    // unified: variant-level truth
    return isProductDiscounted(p);
  }
  function filterNodesBySale(nodes) {
    if (!Array.isArray(nodes)) return [];
    return nodes.filter(isProductOnSale);
  }

  // --- NEW: in-stock only filter for keyword mode (header search / collections/all?k=...)
  // Keeps a product if it has ANY available variant (or availableForSale true if present)
  function productIsInStock(p){
    if (!p) return false;

    // If product.availableForSale exists in the query, use it
    if (typeof p.availableForSale === 'boolean') return p.availableForSale;

    // Otherwise fall back to variants
    if (p.variants && p.variants.nodes && p.variants.nodes.length){
      return p.variants.nodes.some(function(v){
        return !!(v && v.availableForSale);
      });
    }

    // If we don’t have enough data, do NOT drop it (avoid “breaking” compact queries)
    return true;
  }

  function filterNodesByInStock(nodes){
    if (!Array.isArray(nodes)) return [];
    return nodes.filter(productIsInStock);
  }



  // convenience
  function onSaleRoute() {
    try {
      var u = new URL(window.location.href);
      var parts = u.pathname.split('/').filter(Boolean);
      return (parts[0] === 'collections' && String(parts[1] || '').toLowerCase() === String(SALE_COLLECTION_HANDLE).toLowerCase());
    } catch(_) { return false; }
  }



  function isProductInSaleCollection(p) {
    if (!p || !p.collections || !p.collections.nodes) return false;
    for (var i = 0; i < p.collections.nodes.length; i++) {
      var h = (p.collections.nodes[i] && p.collections.nodes[i].handle) || '';
      if (String(h).toLowerCase() === String(SALE_COLLECTION_HANDLE).toLowerCase()) return true;
    }
    return false;
  }


  // Read the checkbox once whenever we need it
  function saleOnlySelected() {
    var el = document.getElementById('checkbox_show_only_sale_items');
    var onSaleCollection = isOnCollectionHandle(SALE_COLLECTION_HANDLE);
    // When we're viewing /collections/sale, do not apply extra client-side sale filters.
    return !!(el && el.checked && !onSaleCollection);
  }


// ---- Activity "includes" matching helpers ----

  // Get activities selected from the UI (left filters)
  function getSelectedActivitiesFromUI() {
    var out = [];
    document.querySelectorAll('input[name="footwear_activity[]"]:checked').forEach(function (el) {
      var v = (el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  // Get activities that came from URL (?activity=Walking or ?activity=Walk,...)
  function getSelectedActivitiesFromURL() {
    // uses your existing URL parser
    return getURLMultiValues('activity'); // already handles repeated & comma-separated values
  }

  function getWidthSelections(){
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="footwear_width[]"]:checked')
    ).map(function(el){ return String(el.value || '').trim(); })
    .filter(Boolean);
  }

  // ✅ Footwear colors from <input name="footwear_color[]">
  function getFootwearColorSelections() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="footwear_color[]"]:checked')
    ).map(function (el) {
      return String(el.value || '').trim();
    }).filter(Boolean);
  }

  // ✅ Clothing colors from <input name="clothing_color[]">
  function getClothingColorSelections() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="clothing_color[]"]:checked')
    ).map(function (el) {
      return String(el.value || '').trim();
    }).filter(Boolean);
  }

  // ✅ Unified: whichever category is active drives which color group applies
  function getColorSelections() {
    // If only one category is active, use its colors
    if (isCategoryActive && isCategoryActive('footwear')) return getFootwearColorSelections();
    if (isCategoryActive && isCategoryActive('clothing')) return getClothingColorSelections();

    // If neither category is explicitly active (ex: /collections/all), combine both
    var a = getFootwearColorSelections();
    var b = getClothingColorSelections();
    var seen = {};
    return a.concat(b).filter(function (x) {
      if (seen[x]) return false;
      seen[x] = true;
      return true;
    });
  }



  // Union + de-dup activities from UI and URL
  function getActivitySelections() {
    var uiVals  = getSelectedActivitiesFromUI();
    var urlVals = getSelectedActivitiesFromURL();
    var seen = {};
    var all  = [];
    uiVals.concat(urlVals).forEach(function (v) {
      var key = String(v).trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      all.push(key);
    });
    return all;
  }

  function getInjurySelections(){
    var els = document.querySelectorAll('input[name="footwear_injury[]"]:checked');
    var out = [];
    els.forEach(function(el){
      var v = String(el.value || '').trim();
      if (v) out.push(v);
    });
    return out;
  }

  function normalizeToken(s){
    return String(s || '')
      .trim()
      .toLowerCase();
  }

  // Splits "A, B, C" into ["a","b","c"] safely
  function splitCSVMetafieldValue(raw){
    if (!raw) return [];
    return String(raw)
      .split(',')
      .map(function(x){ return normalizeToken(x); })
      .filter(Boolean);
  }

  function productMatchesInjuryCSV(product, selectedInjuries){
    if (!selectedInjuries || !selectedInjuries.length) return true;

    var values = getProductInjuryTokens(product);
    if (!values.length) return false;

    for (var i = 0; i < selectedInjuries.length; i++){
      var sel = normalizeToken(selectedInjuries[i]);
      if (values.indexOf(sel) !== -1) return true;
    }

    return false;
  }

  function filterNodesByInjuryCSV(nodes, selectedInjuries){
    if (!nodes || !nodes.length) return nodes || [];
    if (!selectedInjuries || !selectedInjuries.length) return nodes;
    return nodes.filter(function(p){
      return productMatchesInjuryCSV(p, selectedInjuries);
    });
  }



  // Case-insensitive "includes" with comma-separated admin data (e.g., "Walking, Working, Trail")
  function productMatchesActivity(p, selections) {
    if (!Array.isArray(selections) || !selections.length) return true; // no filter active
    var raw = (p && p.activityMF && typeof p.activityMF.value === 'string') ? p.activityMF.value : '';
    if (!raw) return false; // if filter is active but product has no value, exclude
    var hay = raw.toLowerCase();
    return selections.some(function (needle) {
      return hay.indexOf(String(needle).toLowerCase()) !== -1;
    });
  }



  // Filter a node array down to products that have *any* available variant in the selected sizes
  function filterNodesByAvailableSizes(nodes, sizes) {
    if (!Array.isArray(nodes) || !sizes || !sizes.length) return nodes;
    var optName = getActiveSizeOptionName();
    return nodes.filter(function(p){
      // keep product if it has at least one chosen size that is in stock
      return sizes.some(function(sz){ return productHasAvailableSize(p, optName, sz); });
    });
  }

  // --- Slick safety: destroy old instances before (re)initializing
// Only initialize sliders that aren't initialized yet.
  // DO NOT unslick existing ones (keeps top cards intact).
  function safeReinitSlick(containerEl){
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
    initSlickFor(containerEl);
  }


  // --- Render pagination controls under the grid
  function renderPagination(){
    var pagWrapId = 'sf-pagination';
    var wrap = document.getElementById(pagWrapId);
    if (!wrap) {
      resultsEl.insertAdjacentHTML('beforeend', '<div id="'+pagWrapId+'" class="sf-pagination" style="width:100%;display:flex;justify-content:center;gap:.5rem;margin:1rem 0;flex-wrap:wrap;"></div>');
      wrap = document.getElementById(pagWrapId);
    }

    var cur   = pageState.current;
    var lastFetched = pageState.maxFetched;          // highest page actually fetched (logical pages)
    var hasNextFromLastFetched = pageState.hasNext;  // API hinted there may be another logical page
    var windowSize = 6;

    // We will only show pages we truly know about:
    // - everything we have fetched (1..lastFetched)
    // - PLUS one "look-ahead" page if API says there's possibly more
    var knownMax = Math.max(1, lastFetched + (hasNextFromLastFetched ? 1 : 0));

    // Build a tight window around the current page, but never beyond knownMax
    var half = Math.floor((windowSize - 1) / 2);
    var start = Math.max(1, cur - half);
    var end = Math.min(knownMax, start + windowSize - 1);
    // Back-adjust start if we clipped the end
    start = Math.max(1, end - windowSize + 1);


    // Render buttons
    var html = '';
    html += '<button class="sf-page-btn" data-page="'+(cur-1)+'" '+(cur<=1?'disabled':'')+'></button>';

    for (var p = start; p <= end; p++){
      html += '<button class="sf-page-btn'+(p===cur?' active':'')+'" data-page="'+p+'">'+p+'</button>';
    }

    // Next is enabled if:
    // - current < end (more pages in our window), OR
    // - the API said there may be further pages (hasNext)
    var nextDisabled = !(cur < knownMax);
    html += '<button class="sf-page-btn" data-page="'+(cur+1)+'" '+(nextDisabled?'disabled':'')+'></button>';

    wrap.innerHTML = html;

    // Styles (once)
    var style = document.getElementById('sf-pagination-style');
    if (!style){
      style = document.createElement('style');
      style.id = 'sf-pagination-style';
      style.textContent = '' +
        '.sf-pagination .sf-page-btn{padding:.4rem .7rem;border:1px solid #ddd;background:#fff;cursor:pointer;border-radius:6px}' +
        '.sf-pagination .sf-page-btn[disabled]{opacity:.5;cursor:not-allowed}' +
        '.sf-pagination .sf-page-btn.active{background:#0d6efd;color:#fff;border-color:#0d6efd}';
      document.head.appendChild(style);
    }

    // Click handlers
    wrap.querySelectorAll('.sf-page-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = parseInt(btn.getAttribute('data-page'),10);
        if (!isFinite(target) || target < 1) return;
        goToPage(target); // this will fetch any missing pages in between
      });
    });
  }

  // --- Ensure a sentinel & spinner exist under the results grid
  function ensureInfiniteSentinel(){
    // Create/ensure wrapper once
    var wrapId = 'sf-infinite-wrap';
    var wrap = document.getElementById(wrapId);
    if (!wrap){
      resultsEl.insertAdjacentHTML(
        'beforeend',
        '<div id="'+wrapId+'" style="width:100%;display:flex;flex-direction:column;align-items:center;gap:.5rem;margin:1rem 0;">' +
          '<div id="sf-infinite-spinner" style="display:none;font-size:14px;color:#666;">Loading…</div>' +
          '<div id="sf-infinite-sentinel" style="height:1px;width:100%;"></div>' +
        '</div>'
      );
      wrap = document.getElementById(wrapId);
    }
    return {
      spinner: document.getElementById('sf-infinite-spinner'),
      sentinel: document.getElementById('sf-infinite-sentinel')
    };
  }

  function showInfiniteSpinner(){ var s = document.getElementById('sf-infinite-spinner'); if (s) s.style.display = ''; }
  function hideInfiniteSpinner(){ var s = document.getElementById('sf-infinite-spinner'); if (s) s.style.display = 'none'; }

  // Find the nearest scrolling ancestor we should observe against
  function getScrollRoot(startEl){
    var el = startEl;
    while (el && el !== document.documentElement){
      var cs = window.getComputedStyle(el);
      var overflowY = (cs.overflowY || '').toLowerCase();
      var canScroll = (overflowY === 'auto' || overflowY === 'scroll');
      if (canScroll && el.scrollHeight > el.clientHeight) return el;
      el = el.parentElement;
    }
    // Fallback: the viewport
    return null;
  }


  // Append just the new nodes (no full rerender)
  function appendNodes(nodes){
    if (!nodes || !nodes.length) return;
    // Keep currentNodes in sync so keyword/sale/size client filters remain accurate
    currentNodes = (currentNodes || []).concat(nodes);
    renderProducts(nodes, /*append*/ true);   // your renderer handles chunked append
    setCount(getTotalShown());                // show cumulative count
    safeReinitSlick(resultsEl);
  }

  // Fetch the next logical page (using stored cursor), then append to grid
  function loadNextPageAppend(){
    if (!INFINITE_ENABLED) return;
    if (__inf.loading) return;

    // If no more pages hinted by API or union branches disabled pagination
    if (!pageState.hasNext) return;

    var nextPageNumber = (pageState.current || 1) + 1;

    // If we already fetched it before (e.g., user paged with buttons), reuse cache
    if (pageState.pages[nextPageNumber]){
      pageState.current = nextPageNumber;
      appendNodes(pageState.pages[nextPageNumber].nodes || []);
      renderPagination(); // keep pager in sync with the new "current" index
      return;
    }

    // Fetch using the stored endCursor of the previous page
    var afterCursor = pageState.cursors[nextPageNumber - 1] || null;

    __inf.loading = true;
    showInfiniteSpinner();

    return fetchProducts({ first: PAGE_SIZE, after: afterCursor }).then(function(edge){
      var nodes = (edge && edge.nodes) || [];
      var pageInfo = (edge && edge.pageInfo) || { hasNextPage:false, endCursor:null };

      // Update pagination cache/state
      pageState.pages[nextPageNumber] = { nodes: nodes, pageInfo: pageInfo };
      pageState.maxFetched = Math.max(pageState.maxFetched, nextPageNumber);
      pageState.cursors[nextPageNumber] = pageInfo.endCursor || null;
      pageState.hasNext = !!pageInfo.hasNextPage;

      // Move current pointer forward and append
      pageState.current = nextPageNumber;
      appendNodes(nodes);
      renderPagination();
    }).catch(function(){
      // Fail silently; keeps existing grid intact
    }).finally(function(){
      __inf.loading = false;
      hideInfiniteSpinner();
    });
  }


  // Observe sentinel; when it enters viewport, try to load the next page
  // Observe sentinel; when it enters the *real* scroll container's viewport, load next page
  function ensureInfiniteObserver(){
    if (!INFINITE_ENABLED) return;

    var bits = ensureInfiniteSentinel();
    var sentinel = bits.sentinel;
    if (!sentinel) return;

    // Determine the correct scroll root (null = window)
    var rootEl = getScrollRoot(resultsEl);

    // Reuse observer if we can (but rebuild if root changed)
    if (__inf.observer && __inf.observer.__rootEl === rootEl){
      __inf.observer.disconnect();
      __inf.observer.observe(sentinel);
    } else {
      if (__inf.observer) { try { __inf.observer.disconnect(); } catch(_){} }

      __inf.observer = new IntersectionObserver(function(entries){
        if (!INFINITE_ENABLED) return;
        if (!entries || !entries.length) return;
        var entry = entries[0];
        if (!entry.isIntersecting) return;
        if (!pageState.hasNext) return;
        // Defer slightly to let layout settle
        setTimeout(loadNextPageAppend, 80);
      }, {
        root: rootEl || null,
        // Start loading before the very bottom so users rarely hit a “hard stop”
        rootMargin: '600px 0px 1200px 0px',
        threshold: 0
      });
      __inf.observer.__rootEl = rootEl; // remember which root we bound to
      __inf.observer.observe(sentinel);
    }

    // --- Fallback: throttle manual scroll/resize to poke the loader if IO misses
    // (only attach once per root)
    if (!ensureInfiniteObserver._boundRoot || ensureInfiniteObserver._boundRoot !== (rootEl || window)){
      ensureInfiniteObserver._boundRoot = (rootEl || window);

      var throttle = (function(){
        var t; 
        return function(fn){ if (t) return; t = setTimeout(function(){ t = null; fn(); }, 200); };
      })();

      var onScrollLike = function(){
        // If sentinel is close to the bottom and we still have data, attempt a load
        if (!INFINITE_ENABLED || __inf.loading || !pageState.hasNext) return;

        var wrap = document.getElementById('sf-infinite-wrap');
        if (!wrap) return;

        var rootNode = rootEl || document.documentElement;
        var rootScrollTop = rootEl ? rootEl.scrollTop : window.pageYOffset || document.documentElement.scrollTop;
        var rootClientH   = rootEl ? rootEl.clientHeight : window.innerHeight;
        var wrapTop = wrap.getBoundingClientRect().top + (rootEl ? rootScrollTop : (window.pageYOffset || document.documentElement.scrollTop));

        // Trigger when the sentinel wrapper is within ~1000px of the viewport bottom
        if (wrapTop < (rootScrollTop + rootClientH + 1000)) {
          loadNextPageAppend();
        }
      };

      var target = rootEl || window;
      var evt = rootEl ? 'scroll' : 'scroll';
      target.removeEventListener(evt, ensureInfiniteObserver._scrollHandler || function(){});
      ensureInfiniteObserver._scrollHandler = function(){ throttle(onScrollLike); };
      target.addEventListener(evt, ensureInfiniteObserver._scrollHandler, { passive:true });

      window.removeEventListener('resize', ensureInfiniteObserver._resizeHandler || function(){});
      ensureInfiniteObserver._resizeHandler = function(){ throttle(onScrollLike); };
      window.addEventListener('resize', ensureInfiniteObserver._resizeHandler, { passive:true });
    }
  }



  // --- Reset pagination when filters change
  function resetPagination(){
    pageState.current = 1;
    pageState.pages = {};
    pageState.cursors = [null];  // page 1 uses null "after"
    pageState.hasNext = true;
    pageState.maxFetched = 0;
    var pag = document.getElementById('sf-pagination');
    if (pag) pag.remove();
  }

  // --- Fetch (or reuse cache) then render a page
  function goToPage(targetPage){
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // If we already have it cached, just render
    if (pageState.pages[targetPage]){
      pageState.current = targetPage;
      currentNodes = pageState.pages[targetPage].nodes.slice(0);
      renderProducts(currentNodes, /*append*/ false);
      setCount(getTotalShown());          // cumulative
      safeReinitSlick(resultsEl);
      renderPagination();
      ensureInfiniteSentinel();
      ensureInfiniteObserver();
      return;
    }


    // Otherwise we need to fetch up to that page (using stored cursors sequentially)
    resultsEl.innerHTML = '<p style="padding-left: 20px">Loading…</p>';

    // Determine where to start: we’ve fetched up to pageState.maxFetched
    var startFrom = pageState.maxFetched || 0; // 0 means nothing fetched yet; page 1 needs after=null at index 0
    var promise = Promise.resolve();

    function doFetch(nextPageNumber){
      var afterCursor = pageState.cursors[nextPageNumber-1] || null; // after cursor of previous page number
      return fetchProducts({ first: PAGE_SIZE, after: afterCursor }).then(function(edge){
        var nodes = (edge && edge.nodes) || [];
        var pageInfo = (edge && edge.pageInfo) || { hasNextPage:false, endCursor:null };
        pageState.pages[nextPageNumber] = { nodes: nodes, pageInfo: pageInfo };
        pageState.maxFetched = Math.max(pageState.maxFetched, nextPageNumber);
        pageState.cursors[nextPageNumber] = pageInfo.endCursor || null;
        pageState.hasNext = !!pageInfo.hasNextPage;
      });
    }

    // Queue needed fetches
    for (var n = startFrom + 1; n <= targetPage; n++){
      // If we already have this page, skip
      if (pageState.pages[n]) continue;
      promise = promise.then(doFetch.bind(null, n));
    }

    promise.then(function(){
      // Now render the target page
      var page = pageState.pages[targetPage] || null;
      pageState.current = targetPage;
      currentNodes = (page && page.nodes) ? page.nodes.slice(0) : [];
      renderProducts(currentNodes, /*append*/ false);
      setCount(getTotalShown());          // cumulative
      safeReinitSlick(resultsEl);
      renderPagination();
      ensureInfiniteSentinel();
      ensureInfiniteObserver();
    }).catch(function(){
      resultsEl.innerHTML = '<p>There was a problem loading products.</p>';
      if (countEl) countEl.textContent = '';
    });
 
  }



  // Put this near your other helpers (above fetchProducts)
// Title-only keyword matching (AND across words)
function productMatchesKeyword(p, q) {
  function norm(s){
    return String(s || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/['’`]/g, "'")
      .replace(/[^\w\s'-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  var nq = norm(q);
  if (!nq) return true;

  var title = norm(p && p.title);
  if (!title) return false;

  var terms = nq.split(' ');
  for (var i = 0; i < terms.length; i++){
    if (terms[i] && title.indexOf(terms[i]) === -1) return false;
  }
  return true;
}

// --- PERF: memoized helpers for repeated injury/color filtering ---

function getProductInjuryTokens(product){
  if (!product) return [];

  // memoized on the product object
  if (product.__injuryTokensCache) return product.__injuryTokensCache;

  var raw = null;

  if (product && product.injuryMetafield && product.injuryMetafield.value) {
    raw = product.injuryMetafield.value;
  } else if (product && product.metafield && product.metafield.value) {
    raw = product.metafield.value;
  }

  var tokens = splitCSVMetafieldValue(raw);
  product.__injuryTokensCache = tokens;
  return tokens;
}

function getProductAvailableColorTokens(product){
  if (!product) return [];

  // memoized on the product object
  if (product.__availableColorTokensCache) return product.__availableColorTokensCache;

  var out = [];
  var seen = Object.create(null);

  var vars = (product.variants && product.variants.nodes) ? product.variants.nodes : [];
  for (var i = 0; i < vars.length; i++){
    var variant = vars[i];
    if (!variant || !variant.availableForSale) continue;

    var opts = variant.selectedOptions || [];
    for (var j = 0; j < opts.length; j++){
      if (String(opts[j].name || '').toLowerCase() !== 'color') continue;

      var raw = String(opts[j].value || '').trim().toUpperCase();
      if (!raw) continue;

      // Keep full raw value
      if (!seen[raw]) {
        seen[raw] = true;
        out.push(raw);
      }

      // Also keep a normalized prefix token, e.g. "BLACK" from "BLACK (001)"
      var prefix = raw.split('(')[0].split('-')[0].trim();
      if (prefix && !seen[prefix]) {
        seen[prefix] = true;
        out.push(prefix);
      }
    }
  }

  product.__availableColorTokensCache = out;
  return out;
}

function normalizeSelectedColorTokens(selectedColors){
  var out = [];
  var seen = Object.create(null);

  (selectedColors || []).forEach(function(c){
    var v = String(c || '').trim().toUpperCase();
    if (!v || seen[v]) return;
    seen[v] = true;
    out.push(v);
  });

  return out;
}

// ✅ Normalize helper
function __normColor(s) {
  return String(s || '').trim().toLowerCase();
}

// ✅ Try to read colors from product options/variants/tags, then match against selected colors
function productMatchesColor(product, selectedColors) {
  if (!product) return false;

  var colors = (selectedColors || []).map(function(c){
    return String(c || '').trim().toLowerCase();
  }).filter(Boolean);

  if (!colors.length) return true;

  // 1) Primary source: available variant color tokens (cached)
  try {
    var cached = getProductAvailableColorTokens(product) || [];
    if (cached.length) {
      var matchedCached = colors.some(function (c) {
        return cached.some(function (rawVal) {
          var val = String(rawVal || '').trim().toLowerCase();
          return (
            val === c ||
            val.indexOf(c + ' ') === 0 ||
            val.indexOf(c + '(') === 0 ||
            val.indexOf(c + '-') === 0
          );
        });
      });

      // IMPORTANT:
      // if we had real cached color data, trust it completely
      return matchedCached;
    }
  } catch (_) {}

  // 2) product.options fallback
  try {
    if (product.options && product.options.length) {
      var opt = product.options.find(function (o) {
        var n = String(o && o.name || '').trim().toLowerCase();
        return (n === 'color' || n === 'colour');
      });

      if (opt && opt.values && opt.values.length) {
        var matchedOptions = colors.some(function (c) {
          return opt.values.some(function(v){
            var val = String(v || '').trim().toLowerCase();
            return (
              val === c ||
              val.indexOf(c + ' ') === 0 ||
              val.indexOf(c + '(') === 0 ||
              val.indexOf(c + '-') === 0
            );
          });
        });

        return matchedOptions;
      }
    }
  } catch (_) {}

  // 3) variants.selectedOptions fallback
  try {
    var vs = (product.variants && (product.variants.nodes || product.variants)) || [];
    if (vs.length) {
      var foundAnyColorField = false;

      for (var i = 0; i < vs.length; i++) {
        var so = vs[i] && (vs[i].selectedOptions || []);
        for (var j = 0; j < so.length; j++) {
          var name = String(so[j] && so[j].name || '').trim().toLowerCase();
          var val  = String(so[j] && so[j].value || '').trim().toLowerCase();

          if (name === 'color' || name === 'colour') {
            foundAnyColorField = true;

            for (var k = 0; k < colors.length; k++) {
              var c = colors[k];
              if (
                val === c ||
                val.indexOf(c + ' ') === 0 ||
                val.indexOf(c + '(') === 0 ||
                val.indexOf(c + '-') === 0
              ) {
                return true;
              }
            }
          }
        }
      }

      // IMPORTANT:
      // if variants existed and had color fields, but none matched → false
      if (foundAnyColorField) return false;
    }
  } catch (_) {}

  // 4) tags fallback
  try {
    var tags = (product.tags || []).map(function(t){
      return String(t || '').trim().toLowerCase();
    });

    if (tags.length) {
      return colors.some(function (c) {
        return (
          tags.indexOf(c) !== -1 ||
          tags.indexOf('color_' + c) !== -1 ||
          tags.indexOf('colour_' + c) !== -1 ||
          tags.indexOf('color:' + c) !== -1 ||
          tags.indexOf('colour:' + c) !== -1
        );
      });
    }
  } catch (_) {}

  // If we genuinely have no color data anywhere, keep the product
  // so we don't accidentally blank the collection
  return true;
}

function filterNodesByColors(nodes, selectedColors) {
  var cols = (selectedColors || []);
  if (!cols.length) return nodes || [];
  return (nodes || []).filter(function (p) {
    return productMatchesColor(p, cols);
  });
}


// Returns true if product has a real discount: any variant compare_at > price,
// or (fallback) compareAtPriceRange.minVariantPrice > priceRange.minVariantPrice
function isProductDiscounted(p){
  if (!p) return false;

  // Variant-level check first (most accurate)
  if (p.variants && p.variants.nodes && p.variants.nodes.length) {
    for (var i = 0; i < p.variants.nodes.length; i++){
      var v = p.variants.nodes[i];
      var price = parseFloat(v && v.price && v.price.amount);
      var cmp   = parseFloat(v && v.compareAtPrice && v.compareAtPrice.amount);
      if (isFinite(price) && isFinite(cmp) && cmp > price) return true;
    }
  }

  // Fallback to product price ranges
  var pr  = p && p.priceRange && p.priceRange.minVariantPrice;
  var cpr = p && p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice;
  var prA  = parseFloat(pr && pr.amount);
  var cprA = parseFloat(cpr && cpr.amount);
  if (isFinite(prA) && isFinite(cprA) && cprA > prA) return true;

  return false;
}


// ==============================
// FIT FINDER FALLBACK (ONLY when fit-finder=true)
// ==============================

// Detect fit-finder mode from URL
function isFitFinderMode(){
  try {
    var u = new URL(window.location.href);
    return (u.searchParams.get('fit-finder') || '').trim().toLowerCase() === 'true';
  } catch(_) {
    return false;
  }
}

// ✅ GLOBAL: URL sale flag (Fit Finder needs this too)
function saleParamSelected(){
  try {
    var u = new URL(window.location.href);
    var v = (u.searchParams.get('sale') || '').trim().toLowerCase();
    return (v === '1' || v === 'true' || v === 'yes' || v === 'on');
  } catch (_) {
    return false;
  }
}


// Remove Storefront price filter objects: { price: {min,max} }
function removePriceFromFilters(filters){
  return (filters || []).filter(function(f){
    return !(f && f.price); // price filter object
  });
}

// Remove FEEL metafield filters based on URL_META_MAP['type_of_feel'] (no hardcode!)
function removeFeelFromFilters(filters){
  filters = (filters || []).slice(0);

  var feelMeta = (typeof URL_META_MAP === 'object' && URL_META_MAP) ? URL_META_MAP['type_of_feel'] : null;

  // If mapping is {namespace,key}, remove that metafield filter
  if (feelMeta && typeof feelMeta === 'object' && feelMeta.namespace && feelMeta.key){
    return filters.filter(function(f){
      var pm = f && f.productMetafield;
      if (!pm) return true;
      return !(String(pm.namespace) === String(feelMeta.namespace) && String(pm.key) === String(feelMeta.key));
    });
  }

  // If mapping is "namespace.key", remove that metafield filter
  if (typeof feelMeta === 'string' && feelMeta.indexOf('.') !== -1){
    var parts = feelMeta.split('.');
    var ns = parts[0];
    var key = parts.slice(1).join('.');
    return filters.filter(function(f){
      var pm = f && f.productMetafield;
      if (!pm) return true;
      return !(String(pm.namespace) === String(ns) && String(pm.key) === String(key));
    });
  }

  // If we cannot detect feel mapping safely, do nothing (safe fallback).
  return filters;
}

// Keep ONLY size (variantOption) + available:true.
// We read size from URL param `footwear-size` (Fit Finder always sends it),
// but we also fall back to getActiveSizes() if needed.
function buildSizeOnlyFilters(){
  var params = getURLParams();
  var sizeFromURL = (params.get('footwear-size') || '').trim();

  var sizeVal = sizeFromURL;
  if (!sizeVal) {
    var s = (getActiveSizes && getActiveSizes()) || [];
    sizeVal = (s && s[0]) ? String(s[0]).trim() : '';
  }

  var out = [];

  // Only add size filter if we have one
  if (sizeVal) {
    out.push({ variantOption: { name: FOOTWEAR_SIZE_NAME, value: sizeVal } });
  }

  // Always require in-stock on server
  out.push({ available: true });

  return out;
}

// Raw collection fetch using FULL query so we have variants + activityMF for client filters
function fetchCollectionRawFull(handle, filtersForThisCall, afterCursor, firstCount){
  var sort = getSortFromURL(); // may be null
  var sortLocal = sort || null;

  var variablesCollection = {
    handle: handle,
    first: Math.max(1, firstCount || PAGE_SIZE),
    after: afterCursor || null,
    filters: filtersForThisCall || []
  };
  if (sortLocal) {
    variablesCollection.sortKey = sortLocal.sortKey;
    variablesCollection.reverse = !!sortLocal.reverse;
  }

  return fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SF_TOKEN
    },
    body: JSON.stringify({ query: QUERY_PRODUCTS_FULL_NOQ, variables: variablesCollection })
  })
  .then(function(res){ if(!res.ok) throw new Error('Storefront API ' + res.status); return res.json(); })
  .then(function(json){
    if (json.errors) { console.error('[Shopify GraphQL Errors]', json.errors); throw new Error('GraphQL errors'); }
    var edge = json && json.data && json.data.collection && json.data.collection.products || null;
    return {
      nodes: edge ? (edge.nodes || []) : [],
      pageInfo: edge ? edge.pageInfo : { hasNextPage:false, endCursor:null }
    };
  });
}


// Apply ONLY the client-side filters we want for each step
// NEW: third param enforceSaleStrict lets Fit Finder do a strict-sale pass first,
// then a fallback pass without sale if no sale items exist at all.
// Apply ONLY the client-side filters we want for each step
// NEW: supports forceSaleStrict (used for fit-finder ?sale=true strict pass)
function applyFitFinderClientFilters(nodes, stepIdx, forceSaleStrict){
  nodes = Array.isArray(nodes) ? nodes.slice(0) : [];

  // Size (always for steps 1-4)
  var sizes = [];
  try { sizes = (getActiveSizes && getActiveSizes()) || []; } catch(_) { sizes = []; }
  if (sizes.length) {
    nodes = filterNodesByAvailableSizes(nodes, sizes);
  }

  // SALE:
  // - If forceSaleStrict === true (fit-finder first pass), enforce sale on ALL steps (including step 4)
  // - Otherwise keep old behavior: sale applies only on steps 1-3 when user triggered sale
  if (forceSaleStrict === true) {
    nodes = filterNodesBySale(nodes);
  } else {
    if (stepIdx !== 4) {
      if (
        (typeof saleOnlySelected === 'function' && saleOnlySelected()) ||
        (typeof onSaleRoute === 'function' && onSaleRoute()) ||
        (typeof saleParamSelected === 'function' && saleParamSelected())
      ) {
        nodes = filterNodesBySale(nodes);
      }
    }
  }

  // Activity (ONLY steps 1-3; NOT step 4)
  if (stepIdx !== 4) {
    var act = [];
    try { act = (getActivitySelections && getActivitySelections()) || []; } catch(_) { act = []; }
    if (act.length) {
      nodes = nodes.filter(function(p){ return productMatchesActivity(p, act); });
    }
  }

  return nodes;
}

 
 
// Main Fit Finder cascade fetcher
// Main Fit Finder cascade fetcher
// Main Fit Finder cascade fetcher
// Main Fit Finder cascade fetcher (now supports strict sale pass -> relaxed sale pass)
function fetchProductsFitFinderCascade(){
  var effectiveHandle = getCollectionHandleForQuery(collectionHandle);

  // Start with your normal mergedFilters (includes price, feel, injury, width, cross-train, etc.)
  var base = mergedFilters();

  // Step 1: FULL
  var step1 = base;

  // Step 2: remove Price
  var step2 = removePriceFromFilters(base);

  // Step 3: remove Feel (and price already removed)
  var step3 = removeFeelFromFilters(step2);

  // Step 4: ONLY Size (+ available true)
  var step4 = buildSizeOnlyFilters();

  // Fit Finder should show up to 5 items max
  var TARGET = 5;

  // Fetch chunks until enough matches found
  var FIRST_PULL = 48;
  var MAX_PAGES_PER_STEP = 6;

  // Do we need STRICT sale? (Fit Finder URL has sale=true)
  var wantsStrictSale = false;
  try {
    wantsStrictSale =
      (typeof saleParamSelected === 'function' && saleParamSelected()) ||
      (typeof saleOnlySelected === 'function' && saleOnlySelected()) ||
      (typeof onSaleRoute === 'function' && onSaleRoute());
  } catch(_) {
    wantsStrictSale = false;
  }

  function fetchUntilEnough(stepIdx, filtersForThisStep, forceSaleStrict){
    var collected = [];
    var seen = Object.create(null);
    var after = null;
    var pages = 0;

    function addNodes(list){
      (list || []).forEach(function(p){
        if (!p || !p.id) return;
        if (seen[p.id]) return;
        seen[p.id] = true;
        collected.push(p);
      });
    }

    function loop(){
      if (collected.length >= TARGET) return Promise.resolve(collected.slice(0, TARGET));
      if (pages >= MAX_PAGES_PER_STEP) return Promise.resolve(collected.slice(0, TARGET));

      return fetchCollectionRawFull(effectiveHandle, filtersForThisStep, after, FIRST_PULL)
        .then(function(edge){
          pages++;

          var nodes = (edge && edge.nodes) ? edge.nodes : [];
          var pageInfo = (edge && edge.pageInfo) ? edge.pageInfo : { hasNextPage:false, endCursor:null };

          // Apply filters for this step (with strict sale if requested)
          var filtered = applyFitFinderClientFilters(nodes, stepIdx, forceSaleStrict);

          addNodes(filtered);

          if (!pageInfo.hasNextPage || !pageInfo.endCursor) {
            return collected.slice(0, TARGET);
          }

          after = pageInfo.endCursor;
          return loop();
        })
        .catch(function(){
          return collected.slice(0, TARGET);
        });
    }

    return loop().then(function(list){
      if (!list || !list.length) return null;
      return {
        nodes: list.slice(0, TARGET),
        pageInfo: { hasNextPage: false, endCursor: null },
        __fitFinderStep: stepIdx
      };
    });
  }

  // Run steps 1→4 for a given pass (strict sale or relaxed sale)
  function runPass(forceSaleStrict){
    return fetchUntilEnough(1, step1, forceSaleStrict)
      .then(function(r){ if (r) return r; return fetchUntilEnough(2, step2, forceSaleStrict); })
      .then(function(r){ if (r) return r; return fetchUntilEnough(3, step3, forceSaleStrict); })
      .then(function(r){ if (r) return r; return fetchUntilEnough(4, step4, forceSaleStrict); })
      .then(function(r){
        if (r) return r;

        // FINAL SAFETY: never blank — show in-stock products from this gender collection
        return fetchUntilEnough(0, [{ available: true }], forceSaleStrict).then(function(last){
          if (last) { last.__fitFinderStep = 0; return last; }
          return null;
        });
      });
  }

  // ✅ If sale is requested, do STRICT SALE pass first.
  // ✅ Only if strict pass returns nothing, retry with sale relaxed.
  if (wantsStrictSale) {
    return runPass(true).then(function(strictResult){
      if (strictResult && strictResult.nodes && strictResult.nodes.length) return strictResult;
      return runPass(false).then(function(relaxed){
        return relaxed || { nodes: [], pageInfo: { hasNextPage:false, endCursor:null }, __fitFinderStep: 0 };
      });
    });
  }

  // Normal fit-finder (no sale request)
  return runPass(false).then(function(r){
    return r || { nodes: [], pageInfo: { hasNextPage:false, endCursor:null }, __fitFinderStep: 0 };
  });
}






  // --------- API call ---------
function fetchProducts(opts) {
  opts = opts || {};
  var after = opts.after || null;
  var first = Math.max(1, opts.first || PAGE_SIZE);

  var isKeywordMode = (__keyword && __keyword.trim().length > 0);
  var sort = getSortFromURL(); // may be null
  var baseFilters = isKeywordMode ? [] : mergedFilters();
  // Width selections (Footwear)
  var widthsSelected = getWidthSelections();

  // ✅ Color filter (variant option: Color)
  // Only apply when exactly ONE color is selected (safe)
  var colorsSelected = getColorSelections();




  var sizesSelected = isKeywordMode ? [] : getActiveSizes();

  var __progressEnabled =
    (!isKeywordMode) &&
    (typeof opts.onProgress === 'function') &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );

  function __emitProgress(scansDone){
    if (!__progressEnabled) return;
    try {
      // Use your scan cap as the "100%" definition (Option A)
      var pct = Math.round((scansDone / MAX_SCAN_PAGES) * 100);
      // Avoid showing 100% until done (feels better)
      if (pct >= 100) pct = 99;
      if (pct < 0) pct = 0;
      opts.onProgress(pct);
    } catch(_){}
  }

  var effectiveHandle = getCollectionHandleForQuery(collectionHandle);

  var brandsSelected = getSelectedBrands();
  var accessoriesSelected = getSelectedAccessoryTypes();
  var clothingTypesSelected = getSelectedClothingTypes();

  // ----- (only used when we fall back to root /all) -----
  var params = getURLParams();
  var priceMin = params.get('filter.v.price.gte');
  var priceMax = params.get('filter.v.price.lte');
  var minPrice = (priceMin != null && !isNaN(parseFloat(priceMin))) ? parseFloat(priceMin) : null;
  var maxPrice = (priceMax != null && !isNaN(parseFloat(priceMax))) ? parseFloat(priceMax) : null;

  // Known-handles helper (so we can detect “unknown/custom” collections)
  function isKnownCategoryHandle(h) {
    if (!h) return false;
    var known = {};
    if (typeof CATEGORY_DEFS === 'object' && CATEGORY_DEFS) {
      Object.keys(CATEGORY_DEFS).forEach(function(key){
        var def = CATEGORY_DEFS[key];
        if (!def) return;
        if (def.handle) known[def.handle] = true;
        var byG = def.handlesByGender || {};
        Object.keys(byG).forEach(function(g){ known[byG[g]] = true; });
      });
    }
    if (typeof SALE_COLLECTION_HANDLE === 'string') known[SALE_COLLECTION_HANDLE] = true;
    if (typeof ALL_PRODUCTS_HANDLE === 'string') known[ALL_PRODUCTS_HANDLE] = true;
    return !!known[h];
  }

  // Are any user/UI/URL filters active (other than collection itself)?
  function userFiltersActive() {
    if (isKeywordMode) return true;
    if ((getActiveSizes() || []).length > 0) return true;
    if ((getActivitySelections() || []).length > 0) return true;
    if (saleOnlySelected()) return true;
    if (brandsSelected.length > 0) return true;
    if (clothingTypesSelected.length > 0) return true;
    // accessories: treat >1 child as explicit union selection; 0 or 1 is not necessarily a signal
    if (accessoriesSelected.length > 1) return true;
    if (minPrice != null || maxPrice != null) return true;
    // you can add more here if you later add new URL flags
    return false;
  }

  var unknownCustomCollection = (!isKnownCategoryHandle(effectiveHandle) && effectiveHandle !== ALL_PRODUCTS_HANDLE);

  function matchesBrand(p, selectedBrands){
    if (!selectedBrands || !selectedBrands.length) return true;
    var v = String(p && p.vendor || '');
    var set = {};
    selectedBrands.forEach(function(b){ set[String(b).toLowerCase()] = true; });
    return !!set[v.toLowerCase()];
  }

  function productMatchesPrice(p, min, max){
    if (min == null && max == null) return true;
    function inRange(amount){
      var n = parseFloat(amount);
      if (!isFinite(n)) return false;
      if (min != null && n < min) return false;
      if (max != null && n > max) return false;
      return true;
    }
    if (p && p.variants && p.variants.nodes && p.variants.nodes.length){
      for (var i = 0; i < p.variants.nodes.length; i++){
        var v = p.variants.nodes[i];
        var pa = v && v.price && v.price.amount;
        if (inRange(pa)) return true;
      }
      return false;
    }
    var mp = p && p.priceRange && p.priceRange.minVariantPrice && p.priceRange.minVariantPrice.amount;
    return inRange(mp);
  }

  // Build a raw SF "query" string for keyword search (Storefront handles ranking)
  function buildSFQueryString(q){
    return String(q || '').trim();
  }

  // -------- Root /collections/all fast keyword path --------
// -------- Root /collections/all fast keyword path --------
var useRootAll = (effectiveHandle === ALL_PRODUCTS_HANDLE);
if (useRootAll && isKeywordMode) {
  // Default search sort → newest first when user didn't set sort_by
  var sortLocal = sort || { sortKey: 'CREATED_AT', reverse: true };

  var variablesFast = {
    first: Math.max(first, 100),
    after: null,
    q: buildSFQueryString(__keyword || ''),
    sortKey: sortLocal.sortKey,
    reverse: !!sortLocal.reverse
  };

  return fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
    body: JSON.stringify({ query: QUERY_PRODUCTS_SEARCH_ALL, variables: variablesFast })
  })
  .then(function (res) { if (!res.ok) throw new Error('Storefront API ' + res.status); return res.json(); })
  .then(function (json) {
    if (json.errors) { console.error('[Shopify GraphQL Errors]', json.errors); throw new Error('GraphQL errors'); }
    var edge = json && json.data && json.data.products || null;
    var nodes = edge ? (edge.nodes || []) : [];

    // 🔎 Title-only filtering (AND across words)
    if (nodes.length) {
      var k = (__keyword || '').trim();
      nodes = nodes.filter(function(p){ return productMatchesKeyword(p, k); });
    }

    nodes = filterNodesByInStock(nodes);

    // ✅ Color prefix match (in-stock variants only)
    var colorsSelected = getColorSelections();
    if (nodes.length && colorsSelected.length) {
      nodes = nodes.filter(function(p){ return productMatchesColorPrefixInStock(p, colorsSelected); });
    }


    // keep your existing client-side filters
    if (nodes.length && (getActiveSizes() || []).length > 0) {
      nodes = filterNodesByAvailableSizes(nodes, getActiveSizes());
    }
    // apply true-sale filter if checkbox is on OR we're on /collections/sale
    if (nodes.length && (saleOnlySelected() || onSaleRoute())) {
      nodes = filterNodesBySale(nodes);
    }

    if (nodes.length && (getActivitySelections() || []).length > 0) {
      nodes = nodes.filter(function (p) { return productMatchesActivity(p, getActivitySelections()); });
    }
    if (nodes.length && brandsSelected.length) {
      nodes = nodes.filter(function(p){ return matchesBrand(p, brandsSelected); });
    }
    if (nodes.length && (minPrice != null || maxPrice != null)) {
      nodes = nodes.filter(function(p){ return productMatchesPrice(p, minPrice, maxPrice); });
    }

    // ✅ Color filter
    if (nodes.length && (getColorSelections() || []).length > 0) {
      nodes = filterNodesByColors(nodes, getColorSelections());
    }


    return { pageInfo: edge ? edge.pageInfo : { hasNextPage:false, endCursor:null }, nodes: nodes.slice(0, first) };
  });
}

  // --------------------------------------------------------
function saleParamSelected() {
  try {
    var u = new URL(window.location.href);
    var v = (u.searchParams.get('sale') || '').trim().toLowerCase();
    return (v === '1' || v === 'true' || v === 'yes' || v === 'on');
  } catch (_) {
    return false;
  }
}

// ✅ Color selections from UI (uppercase values)
function getColorSelections(){
  var els = document.querySelectorAll('input[name="footwear_color[]"]:checked, input[name="clothing_color[]"]:checked');
  var out = [];
  els.forEach(function(el){
    var v = String(el.value || '').trim();
    if (v) out.push(v.toUpperCase());
  });
  return out;
}

// ✅ Injury selections from UI
function getInjurySelections(){
  var els = document.querySelectorAll('input[name="footwear_injury[]"]:checked');
  var out = [];
  els.forEach(function(el){
    var v = String(el.value || '').trim();
    if (v) out.push(v);
  });
  return out;
}

// --- CSV helpers ---
function normalizeToken(s){
  return String(s || '').trim().toLowerCase();
}

function splitCSVMetafieldValue(raw){
  if (!raw) return [];
  return String(raw)
    .split(',')
    .map(function(x){ return normalizeToken(x); })
    .filter(Boolean);
}

// ✅ product must have injuryMetafield: metafield(...) { value } added in query
function productMatchesInjury(product, selectedInjuries){
  if (!selectedInjuries || !selectedInjuries.length) return true;

  var raw = product && product.injuryMetafield && product.injuryMetafield.value;
  if (!raw) return false;

  // Split comma-separated values from metafield
  var productValues = String(raw)
    .split(',')
    .map(function(v){ return v.trim().toLowerCase(); });

  // Match if ANY selected injury exists inside CSV list
  return selectedInjuries.some(function(sel){
    return productValues.indexOf(String(sel).trim().toLowerCase()) !== -1;
  });
}


function filterNodesByInjuryCSV(nodes, selectedInjuries){
  if (!nodes || !nodes.length) return nodes || [];
  if (!selectedInjuries || !selectedInjuries.length) return nodes;
  return nodes.filter(function(p){
    return productMatchesInjuryCSV(p, selectedInjuries);
  });
}


function productMatchesColorPrefixInStock(product, selectedColors){
  if (!product || !selectedColors || !selectedColors.length) return true;

  var productColors = getProductAvailableColorTokens(product);
  if (!productColors.length) return false;

  var wanted = normalizeSelectedColorTokens(selectedColors);

  for (var i = 0; i < wanted.length; i++){
    var c = wanted[i];

    for (var j = 0; j < productColors.length; j++){
      var val = productColors[j];
      if (
        val === c ||
        val.indexOf(c + ' ') === 0 ||
        val.indexOf(c + '(') === 0 ||
        val.indexOf(c + '-') === 0
      ) {
        return true;
      }
    }
  }

  return false;
}


// Call the collection products query once,
// PLUS: fallback for unknown custom collections with no active filters.
// Call the collection products query once,
// PLUS: fallback for unknown custom collections with no active filters.
function callCollectionOnce(filtersForThisCall, afterCursor) {
  var activeSizes        = getActiveSizes() || [];
  var activitySelections = getActivitySelections() || [];
  var colorSelections    = getColorSelections() || [];
  var injurySelections   = getInjurySelections() || [];

  var needSize     = activeSizes.length > 0;
  var needActivity = activitySelections.length > 0;
  var needColor    = colorSelections.length > 0;
  var needInjury   = injurySelections.length > 0;

  // STRICT sale mode:
  var onSaleRoute = isOnCollectionHandle(SALE_COLLECTION_HANDLE);
  var toggleSaleOnly = saleOnlySelected();
  var urlSaleOnly = saleParamSelected();
  var needSaleStrict = !!(onSaleRoute || toggleSaleOnly || urlSaleOnly);

  // If we need post-filtering by size/activity/sale/color/injury, use FULL query
  var queryDocCollection;
  if (needColor || needInjury) {
    queryDocCollection = QUERY_PRODUCTS_SCAN_LIGHT_NOQ;
  } else if (needSize || needActivity || needSaleStrict) {
    queryDocCollection = QUERY_PRODUCTS_FULL_NOQ;
  } else {
    queryDocCollection = QUERY_PRODUCTS_COMPACT_NOQ;
  }

  var sort = getSortFromURL();
  var sortLocal = sort || ((__keyword && __keyword.trim()) ? { sortKey: 'CREATED', reverse: true } : null);

  var variablesCollection = {
    handle: getCollectionHandleForQuery(collectionHandle),
    first: Math.max(1, (needColor || needInjury) ? Math.min(PAGE_SIZE, 12) : PAGE_SIZE),
    after: afterCursor || null,
    filters: filtersForThisCall || []
  };

  if (sortLocal) {
    variablesCollection.sortKey = sortLocal.sortKey;
    variablesCollection.reverse = !!sortLocal.reverse;
  }

  function applyPostFilters(nodes){
    nodes = nodes || [];

    if ((__keyword && __keyword.trim())) {
      var k = __keyword.trim();
      nodes = nodes.filter(function(p){ return productMatchesKeyword(p, k); });
    }

    if ((__keyword && __keyword.trim())) {
      nodes = filterNodesByInStock(nodes);
    }

    if (needSaleStrict && nodes.length) {
      nodes = nodes.filter(isProductDiscounted);
    }

    // cheaper variant-based narrowing first
    if (needSize && nodes.length) {
      nodes = filterNodesByAvailableSizes(nodes, activeSizes);
    }

    if (needActivity && nodes.length) {
      nodes = nodes.filter(function (p) {
        return productMatchesActivity(p, activitySelections);
      });
    }

    // expensive custom filters later, after the list is narrowed
    if (needInjury && nodes.length) {
      nodes = filterNodesByInjuryCSV(nodes, injurySelections);
    }

    if (needColor && nodes.length) {
      nodes = filterNodesByColors(nodes, colorSelections);
    }

    return nodes;
  }

  return fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SF_TOKEN
    },
    body: JSON.stringify({ query: queryDocCollection, variables: variablesCollection })
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Storefront API ' + res.status);
    return res.json();
  })
  .then(function (json) {
    if (json.errors) {
      console.error('[Shopify GraphQL Errors]', json.errors);
      throw new Error('GraphQL errors');
    }

    var edge = json && json.data && json.data.collection && json.data.collection.products || null;

    // Unknown custom collection with no user filters → retry with empty filters once
    var effectiveHandle = variablesCollection.handle;
    var edgeEmpty = (!edge || !edge.nodes || edge.nodes.length === 0);
    var unknownCustomCollection = (function(){
      if (!effectiveHandle) return false;
      var known = {};
      if (typeof CATEGORY_DEFS === 'object' && CATEGORY_DEFS) {
        Object.keys(CATEGORY_DEFS).forEach(function(key){
          var def = CATEGORY_DEFS[key];
          if (!def) return;
          if (def.handle) known[def.handle] = true;
          var byG = def.handlesByGender || {};
          Object.keys(byG).forEach(function(g){ known[byG[g]] = true; });
        });
      }
      if (typeof SALE_COLLECTION_HANDLE === 'string') known[SALE_COLLECTION_HANDLE] = true;
      if (typeof ALL_PRODUCTS_HANDLE === 'string') known[ALL_PRODUCTS_HANDLE] = true;
      return !known[effectiveHandle] && effectiveHandle !== ALL_PRODUCTS_HANDLE;
    })();

    if (edgeEmpty && unknownCustomCollection && !userFiltersActive()) {
      var retryVars = {
        handle: effectiveHandle,
        first: variablesCollection.first,
        after: variablesCollection.after,
        filters: []
      };

      if (sortLocal) {
        retryVars.sortKey = sortLocal.sortKey;
        retryVars.reverse = !!sortLocal.reverse;
      }

      return fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SF_TOKEN
        },
        body: JSON.stringify({ query: QUERY_PRODUCTS_COMPACT_NOQ, variables: retryVars })
      })
      .then(function (res2) {
        if (!res2.ok) throw new Error('Storefront API ' + res2.status);
        return res2.json();
      })
      .then(function (json2) {
        if (json2.errors) {
          console.error('[Shopify GraphQL Errors]', json2.errors);
          throw new Error('GraphQL errors');
        }

        var edge2 = json2 && json2.data && json2.data.collection && json2.data.collection.products || null;
        var nodes2 = edge2 ? (edge2.nodes || []) : [];
        var nodes = applyPostFilters(nodes2);

        return {
          pageInfo: edge2 ? edge2.pageInfo : { hasNextPage:false, endCursor:null },
          nodes: nodes
        };
      });
    }

    var nodes = edge ? (edge.nodes || []) : [];
    nodes = applyPostFilters(nodes);

    return {
      pageInfo: edge ? edge.pageInfo : { hasNextPage:false, endCursor:null },
      nodes: nodes
    };
  });
}




// Call the collection products query once for a specific handle (explicit handle override)
// Call the collection products query once for a specific handle (explicit handle override)
function callCollectionForHandleOnce(explicitHandle, filtersForThisCall, afterCursor) {
  var activeSizes        = getActiveSizes() || [];
  var activitySelections = getActivitySelections() || [];
  var colorSelections    = getColorSelections() || [];
  var injurySelections   = getInjurySelections() || [];

  var needSize     = activeSizes.length > 0;
  var needActivity = activitySelections.length > 0;
  var needColor    = colorSelections.length > 0;
  var needInjury   = injurySelections.length > 0;

  var onSaleRoute = isOnCollectionHandle(SALE_COLLECTION_HANDLE);
  var toggleSaleOnly = saleOnlySelected();
  var urlSaleOnly = saleParamSelected();
  var needSaleStrict = !!(onSaleRoute || toggleSaleOnly || urlSaleOnly);

  var queryDocCollection;
  if (needColor || needInjury) {
    queryDocCollection = QUERY_PRODUCTS_SCAN_LIGHT_NOQ;
  } else if (needSize || needActivity || needSaleStrict) {
    queryDocCollection = QUERY_PRODUCTS_FULL_NOQ;
  } else {
    queryDocCollection = QUERY_PRODUCTS_COMPACT_NOQ;
  }

  var sort = getSortFromURL();
  var sortLocal = sort || ((__keyword && __keyword.trim()) ? { sortKey: 'CREATED', reverse: true } : null);

  var variablesCollection = {
    handle: explicitHandle,
    first: Math.max(1, (needColor || needInjury) ? Math.min(PAGE_SIZE, 12) : PAGE_SIZE),
    after: afterCursor || null,
    filters: filtersForThisCall || []
  };

  if (sortLocal) {
    variablesCollection.sortKey = sortLocal.sortKey;
    variablesCollection.reverse = !!sortLocal.reverse;
  }

  return fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SF_TOKEN
    },
    body: JSON.stringify({ query: queryDocCollection, variables: variablesCollection })
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Storefront API ' + res.status);
    return res.json();
  })
  .then(function (json) {
    if (json.errors) {
      console.error('[Shopify GraphQL Errors]', json.errors);
      throw new Error('GraphQL errors');
    }

    var edge = json && json.data && json.data.collection && json.data.collection.products || null;
    var nodes = edge ? (edge.nodes || []) : [];

    if ((__keyword && __keyword.trim())) {
      var k = __keyword.trim();
      nodes = nodes.filter(function(p){ return productMatchesKeyword(p, k); });
      nodes = filterNodesByInStock(nodes);
    }

    if (needSaleStrict && nodes.length) {
      nodes = nodes.filter(isProductDiscounted);
    }

    if (needSize && nodes.length) {
      nodes = filterNodesByAvailableSizes(nodes, activeSizes);
    }

    if (needActivity && nodes.length) {
      nodes = nodes.filter(function (p) {
        return productMatchesActivity(p, activitySelections);
      });
    }

    if (needInjury && nodes.length) {
      nodes = filterNodesByInjuryCSV(nodes, injurySelections);
    }

    if (needColor && nodes.length) {
      nodes = filterNodesByColors(nodes, colorSelections);
    }

    return {
      pageInfo: edge ? edge.pageInfo : { hasNextPage:false, endCursor:null },
      nodes: nodes
    };
  });
}



 

  // Fallback for /collections/all → use top-level products{} (no keyword fast-path here; that’s handled above)
  function callRootAllOnce(afterCursor) {
    var variables = { first: first, after: afterCursor || null };
    if (sort) { variables.sortKey = sort.sortKey; variables.reverse = !!sort.reverse; }

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: QUERY_PRODUCTS_FULL_ALL_NOQ, variables: variables })
    })
    .then(function (res) { if (!res.ok) throw new Error('Storefront API ' + res.status); return res.json(); })
    .then(function (json) {
      if (json.errors) { console.error('[Shopify GraphQL Errors]', json.errors); throw new Error('GraphQL errors'); }
      var edge = json && json.data && json.data.products || null;
      if (!edge) return { nodes: [], pageInfo: { hasNextPage:false, endCursor:null } };

      var nodes = edge.nodes || [];

      if (isKeywordMode) {
        var k = __keyword.trim();
        nodes = nodes.filter(function(p){ return productMatchesKeyword(p, k); });
      }

      if (nodes.length && (getActiveSizes() || []).length > 0) {
        nodes = filterNodesByAvailableSizes(nodes, getActiveSizes());
      }

      // ✅ include ?sale=true as sale trigger
      if (nodes.length && (saleOnlySelected() || onSaleRoute() || saleParamSelected())) {
        nodes = filterNodesBySale(nodes);
      }

      // ✅ Color filter
      if (nodes.length && (getColorSelections() || []).length > 0) {
        nodes = filterNodesByColors(nodes, getColorSelections());
      }


      if (nodes.length && (getActivitySelections() || []).length > 0) {
        nodes = nodes.filter(function (p) { return productMatchesActivity(p, getActivitySelections()); });
      }
      if (nodes.length && brandsSelected.length) {
        nodes = nodes.filter(function(p){ return matchesBrand(p, brandsSelected); });
      }
      if (nodes.length && (minPrice != null || maxPrice != null)) {
        nodes = nodes.filter(function(p){ return productMatchesPrice(p, minPrice, maxPrice); });
      }

      // ✅ Color prefix match (in-stock variants only)
      var colorsSelected = getColorSelections();
      if (nodes.length && colorsSelected.length) {
        nodes = nodes.filter(function(p){ return productMatchesColorPrefixInStock(p, colorsSelected); });
      }


      return { pageInfo: edge.pageInfo, nodes: nodes };
    });
  }


  function withoutFilterType(filters, keyName){
    return (filters || []).filter(function(f){
      return !f || f[keyName] == null;
    });
  }

  // ✅ Remove ONLY the Color variantOption filter from filters array
  function withoutColorVariantOption(filters) {
    return (filters || []).filter(function (f) {
      var vo = f && f.variantOption;
      if (!vo) return true;
      var n = String(vo.name || '').trim().toLowerCase();
      return (n !== String(COLOR_OPTION_NAME).toLowerCase());
    });
  }


  function withoutWidthMetafield(filters){
    return (filters || []).filter(function(f){
      var pm = f && f.productMetafield;
      if (!pm) return true;
      return !(pm.namespace === FOOTWEAR_WIDTH_META_KEY.namespace && pm.key === FOOTWEAR_WIDTH_META_KEY.key);
    });
  }


  // ---- ALL FOOTWEAR (union of men's + women's) when fw_all=1 is active (with pagination) ----
  var fwAllUnionOn = isAllFootwearParamOn();
  if (!isKeywordMode && fwAllUnionOn && isCategoryActive && isCategoryActive('footwear')) {
    var menHandle   = CATEGORY_DEFS && CATEGORY_DEFS.footwear && CATEGORY_DEFS.footwear.handlesByGender && CATEGORY_DEFS.footwear.handlesByGender.men;
    var womenHandle = CATEGORY_DEFS && CATEGORY_DEFS.footwear && CATEGORY_DEFS.footwear.handlesByGender && CATEGORY_DEFS.footwear.handlesByGender.women;

    if (!menHandle || !womenHandle) {
      // If we don't know both handles, fall back to normal path.
    } else {
      // ── Combined cursor helpers ───────────────────────────────────────────────
      function buildFwAllCursor(menC, womenC){
        try { return '__FWALL__' + btoa(JSON.stringify({ men: menC || null, women: womenC || null })); }
        catch(_){ return '__FWALL__' + JSON.stringify({ men: menC || null, women: womenC || null }); }
      }
      function parseFwAllCursor(s){
        if (!s || typeof s !== 'string') return {men:null, women:null};
        if (s.indexOf('__FWALL__') !== 0) return {men:null, women:null};
        var payload = s.slice('__FWALL__'.length);
        try {
          var obj;
          try { obj = JSON.parse(atob(payload)); }
          catch(_){ obj = JSON.parse(payload); }
          return { men: obj.men || null, women: obj.women || null };
        } catch(_){ return {men:null, women:null}; }
      }

      // ── One union page fetch ─────────────────────────────────────────────────
      function fetchFootwearUnionPage(firstCount, afterCursorCombined){
        var curs = parseFwAllCursor(afterCursorCombined);
        var menAfter   = curs.men   || null;
        var womenAfter = curs.women || null;

        var nodes = [];
        var menDone = false,  womenDone = false;
        var menHasNext = true, womenHasNext = true;

        function fetchMen(){
          if (menDone) return Promise.resolve();
          return callCollectionForHandleOnce(menHandle, baseFilters, menAfter).then(function(p){
            var ns = (p && p.nodes) || [];
            nodes = nodes.concat(ns);
            menHasNext = !!(p && p.pageInfo && p.pageInfo.hasNextPage);
            menAfter   = (p && p.pageInfo && p.pageInfo.endCursor) || null;
            if (!menHasNext || !ns.length) menDone = true;
          });
        }
        function fetchWomen(){
          if (womenDone) return Promise.resolve();
          return callCollectionForHandleOnce(womenHandle, baseFilters, womenAfter).then(function(p){
            var ns = (p && p.nodes) || [];
            nodes = nodes.concat(ns);
            womenHasNext = !!(p && p.pageInfo && p.pageInfo.hasNextPage);
            womenAfter   = (p && p.pageInfo && p.pageInfo.endCursor) || null;
            if (!womenHasNext || !ns.length) womenDone = true;
          });
        }

        // Alternate pulls from men/women until we have enough or both are exhausted
        return (function loop(){
          if (nodes.length >= firstCount || (menDone && womenDone)) {
            var trimmed = nodes.slice(0, firstCount);
            var hasMore = ( (!menDone && menHasNext) || (!womenDone && womenHasNext) );
            var combinedCursor = hasMore ? buildFwAllCursor(menAfter, womenAfter) : null;
            return Promise.resolve({ nodes: trimmed, pageInfo: { hasNextPage: !!hasMore, endCursor: combinedCursor } });
          }
          // Round-robin: men then women
          var seq = Promise.resolve();
          if (!menDone)   seq = seq.then(fetchMen);
          if (nodes.length < firstCount && !womenDone) seq = seq.then(fetchWomen);
          return seq.then(loop);
        })();
      }

      // Kick the union page fetch using our combined cursor (opts.after)
      return fetchFootwearUnionPage(first, opts.after || null);
    }
  }




  // ---- COMBO: multiple brands AND multiple sizes -> union
  if (!isKeywordMode && (brandsSelected.length > 1) && (sizesSelected.length > 1)) {
    var MAX_COMBOS = 12;
    var combos = [];
    for (var i = 0; i < brandsSelected.length; i++) {
      for (var j = 0; j < sizesSelected.length; j++) {
        combos.push({ brand: brandsSelected[i], size: sizesSelected[j] });
      }
    }
    if (combos.length > MAX_COMBOS) {
      combos = brandsSelected.map(function(b){ return { brand: b, size: sizesSelected[0] }; });
    }
    var baseNoBrandNoSize = withoutFilterType(withoutFilterType(baseFilters, 'productVendor'), 'variantOption');
    var calls = combos.map(function (pair) {
      var f = baseNoBrandNoSize.slice(0);
      f.push({ productVendor: pair.brand });
      f.push({ variantOption: { name: FOOTWEAR_SIZE_NAME, value: pair.size } });
      return callCollectionOnce(f);
    });
    return Promise.all(calls).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });
      return { nodes: allNodes.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }
  // ---- MULTI-ACCESSORY TYPES union
  if (!isKeywordMode && accessoriesSelected.length > 1) {
    var baseNoChild = (baseFilters || []).filter(function(f){
      if (!f || !f.productMetafield) return true;
      var pm = f.productMetafield;
      return !(pm.namespace === ACCESSORY_CHILD_META_KEY.namespace && pm.key === ACCESSORY_CHILD_META_KEY.key);
    });
    var parentGate = { productMetafield: { namespace: ACCESSORY_PARENT_META.namespace, key: ACCESSORY_PARENT_META.key, value: ACCESSORY_PARENT_META.value } };
    var ensureParent = function(arr){
      var hasParent = (arr || []).some(function(f){
        var pm = f && f.productMetafield;
        return pm && pm.namespace === ACCESSORY_PARENT_META.namespace && pm.key === ACCESSORY_PARENT_META.key && pm.value === ACCESSORY_PARENT_META.value;
      });
      if (!hasParent) arr.push(parentGate);
      return arr;
    };
    var callsA = accessoriesSelected.map(function (childVal) {
      var f = baseNoChild.slice(0);
      ensureParent(f);
      f.push({ productMetafield: { namespace: ACCESSORY_CHILD_META_KEY.namespace, key: ACCESSORY_CHILD_META_KEY.key, value: childVal } });
      return callCollectionOnce(f);
    });
    return Promise.all(callsA).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });
      return { nodes: allNodes.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }

  // ---- MULTI-BRAND ONLY
  if (!isKeywordMode && brandsSelected.length > 1) {
    var baseNoBrand = withoutFilterType(baseFilters, 'productVendor');
    var callsB = brandsSelected.map(function (brand) {
      var f = baseNoBrand.slice(0);
      f.push({ productVendor: brand });
      return callCollectionOnce(f);
    });
    return Promise.all(callsB).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });
      return { nodes: allNodes.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }

  // ---- MULTI clothing types & sizes
  if (!isKeywordMode && clothingTypesSelected.length > 1 && sizesSelected.length > 1 && isCategoryActive && isCategoryActive('clothing')) {
    var MAX_COMBOS2 = 12;
    var combos2 = [];
    for (var a = 0; a < clothingTypesSelected.length; a++) {
      for (var b = 0; b < sizesSelected.length; b++) {
        combos2.push({ type: clothingTypesSelected[a], size: sizesSelected[b] });
      }
    }
    if (combos2.length > MAX_COMBOS2) {
      combos2 = clothingTypesSelected.map(function(t){ return { type: t, size: sizesSelected[0] }; });
    }
    var baseNoTypeNoSize = withoutFilterType(withoutFilterType(baseFilters, 'productType'), 'variantOption');
    var calls2 = combos2.map(function (pair) {
      var f = baseNoTypeNoSize.slice(0);
      f.push({ productType: pair.type });
      f.push({ variantOption: { name: CLOTHING_SIZE_OPTION_NAME, value: pair.size } });
      return callCollectionOnce(f);
    });
    return Promise.all(calls2).then(function (pages) {
      var seen2 = {}, allNodes2 = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen2[n.id]) { seen2[n.id] = true; allNodes2.push(n); }
        });
      });
      return { nodes: allNodes2.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }

  // ---- MULTI clothing types only
  if (!isKeywordMode && clothingTypesSelected.length > 1 && isCategoryActive && isCategoryActive('clothing')) {
    var baseNoType = withoutFilterType(baseFilters, 'productType');
    var calls3 = clothingTypesSelected.map(function (t) {
      var f = baseNoType.slice(0);
      f.push({ productType: t });
      return callCollectionOnce(f);
    });
    return Promise.all(calls3).then(function (pages) {
      var seen3 = {}, allNodes3 = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen3[n.id]) { seen3[n.id] = true; allNodes3.push(n); }
        });
      });
      return { nodes: allNodes3.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }

  // ✅ Width filter (custom.online_width)
  // Only apply when exactly ONE width is selected (safe; won’t break anything)
  if (widthsSelected && widthsSelected.length === 1) {
    baseFilters.push({
      productMetafield: {
        namespace: 'custom',
        key: 'online_width',
        value: String(widthsSelected[0]).trim()
      }
    });
  }


  // ---- MULTI sizes
  if (!isKeywordMode && sizesSelected.length > 1) {
    var calls4 = sizesSelected.map(function (sizeVal) {
      var f = baseFilters.filter(function (x) { return !x.variantOption; });
      f.push({ variantOption: { name: FOOTWEAR_SIZE_NAME, value: sizeVal } });
      return callCollectionOnce(f);
    });
    return Promise.all(calls4).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        if (!page) return;
        (page.nodes || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });
      return {
        nodes: allNodes.slice(0, first),
        pageInfo: { hasNextPage: false, endCursor: null }
      };
    });
  }

  // ---- MULTI colors (OR union)
  var colorsSelected = getColorSelections();
  if (!isKeywordMode && colorsSelected.length > 1) {
    var baseNoColor = withoutColorVariantOption(baseFilters);

    var callsC = colorsSelected.map(function (cVal) {
      var f = baseNoColor.slice(0);
      f.push({ variantOption: { name: COLOR_OPTION_NAME, value: String(cVal).trim() } });
      return callCollectionOnce(f);
    });

    return Promise.all(callsC).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });

      // ✅ safety post-filter (if API didn’t filter as expected)
      allNodes = filterNodesByColors(allNodes, colorsSelected);

      return { nodes: allNodes.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }


  // ---- MULTI widths (OR union)
  var widthsSelected = getWidthSelections();
  if (!isKeywordMode && widthsSelected.length > 1) {
    var baseNoWidth = withoutWidthMetafield(baseFilters);

    var callsW = widthsSelected.map(function (wVal) {
      var f = baseNoWidth.slice(0);
      f.push({
        productMetafield: {
          namespace: FOOTWEAR_WIDTH_META_KEY.namespace,
          key: FOOTWEAR_WIDTH_META_KEY.key,
          value: wVal
        }
      });
      return callCollectionOnce(f);
    });

    return Promise.all(callsW).then(function (pages) {
      var seen = {};
      var allNodes = [];
      pages.forEach(function (page) {
        ((page && page.nodes) || []).forEach(function (n) {
          if (!seen[n.id]) { seen[n.id] = true; allNodes.push(n); }
        });
      });
      return { nodes: allNodes.slice(0, first), pageInfo: { hasNextPage: false, endCursor: null } };
    });
  }


  // ---- Normal path (including collections that are NOT "all")
  var scanHeavyMode =
    (!isKeywordMode) &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );
  // ✅ Progressive render enabled ONLY when Injury/Color is selected, and caller provided onPartial
  var __progressivePartial =
    (!isKeywordMode) &&
    (typeof opts.onPartial === 'function') &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );

  function __emitPartial(nodesPreview, pageInfoPreview){
    if (!__progressivePartial) return;

    // ✅ OPTION 1: don't emit empty lists (prevents early "No products found")
    if (!nodesPreview || !nodesPreview.length) return;

    try {
      opts.onPartial({
        nodes: (nodesPreview || []).slice(0),
        pageInfo: pageInfoPreview || { hasNextPage: true, endCursor: null }
      });
    } catch(_){}
  }
  
  // ---- Normal path (including collections that are NOT "all")
  return (function fetchFilteredPageAccum(accNodes, afterCursor, scans, lastEndCursor){
    scans = scans || 0;
    if (scans >= MAX_SCAN_PAGES) {
      var trimmed = accNodes.slice(0, first);
      return Promise.resolve({
        nodes: trimmed,
        pageInfo: { hasNextPage: true, endCursor: lastEndCursor || afterCursor || null }
      });
    }
    return callCollectionOnce(baseFilters, afterCursor).then(function(edge){
      var nodes = (edge && edge.nodes) || [];
      var pageInfo = (edge && edge.pageInfo) || { hasNextPage:false, endCursor:null };
      __emitProgress(scans + 1);
      var combined = accNodes.concat(nodes);
      // ✅ Progressive update: show what we have so far (up to "first")
      __emitPartial(combined.slice(0, first), { hasNextPage: true, endCursor: pageInfo.endCursor || null });
      if (combined.length >= first || !pageInfo.hasNextPage) {
        var trimmed = combined.slice(0, first);
        return {
          nodes: trimmed,
          pageInfo: { hasNextPage: pageInfo.hasNextPage, endCursor: pageInfo.endCursor }
        };
      }
      var nextAfter = pageInfo.endCursor || null;
      return fetchFilteredPageAccum(combined, nextAfter, scans + 1, nextAfter);
    });
  })([], after, 0, null);
}





function runSearch() {
  console.debug('[runSearch]',
    'active=', (function(){ return ['footwear','clothing','accessories','smr'].filter(isCategoryActive); })(),
    'genderFootwear=', getGenderForCategory('footwear'),
    'genderClothing=', getGenderForCategory('clothing'),
    'handle=', getCollectionHandleForQuery(collectionHandle)
  );

  function ensureProgressBar(){
    var wrap = document.querySelector('.progress-bar-wrapper');
    if (wrap) return wrap;

    wrap = document.createElement('div');
    wrap.className = 'progress-bar-wrapper';
    wrap.innerHTML = '<div class="box"><div class="bar" style="width:0%"></div></div>';

    // Put it above results (safe & visible)
    var results = document.getElementById('sf-results');
    if (results && results.parentNode) {
      results.parentNode.insertBefore(wrap, results);
    } else {
      document.body.appendChild(wrap);
    }
    return wrap;
  }

  function setProgressBarPct(pct){
    var wrap = ensureProgressBar();
    var bar = wrap ? wrap.querySelector('.bar') : null;
    if (!bar) return;
    var p = Math.max(0, Math.min(100, Number(pct) || 0));
    bar.style.width = p + '%';
  }

  function removeProgressBar(){
    var wrap = document.querySelector('.progress-bar-wrapper');
    if (wrap) wrap.remove();
  }

  function ensureProgressBar(){
    var wrap = document.querySelector('.progress-bar-wrapper');
    if (wrap) return wrap;

    wrap = document.createElement('div');
    wrap.className = 'progress-bar-wrapper';
    wrap.innerHTML = '<div class="progress-bar-wrapper"> <div class="box"> <div class="bar-outer"> <div class="bar"></div> </div><span> Loading...</span> </div> </div>';

    // Put it above results (safe & visible)
    var results = document.getElementById('sf-results');
    if (results && results.parentNode) {
      results.parentNode.insertBefore(wrap, results);
    } else {
      document.body.appendChild(wrap);
    }
    return wrap;
  }

  function setProgressBarPct(pct){
    var wrap = ensureProgressBar();
    var bar = wrap ? wrap.querySelector('.bar') : null;
    if (!bar) return;
    var p = Math.max(0, Math.min(100, Number(pct) || 0));
    bar.style.width = p + '%';
  }

  function removeProgressBar(){
    var wrap = document.querySelector('.progress-bar-wrapper');
    if (wrap) wrap.remove();
  }

  // Always show Loading immediately
  // Detect fit finder ONCE and use this flag everywhere
  var fitFinderOn = isFitFinderMode();

  // Injury/Color progressive mode only (no keyword, no fit finder)
  var progressiveOn =
    !fitFinderOn &&
    !(typeof __keyword === 'string' && __keyword.trim().length > 0) &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );

  // Reset results area
  resultsEl.innerHTML = '';

  // Show progress bar ONLY for injury/color scans
  if (progressiveOn) {
    ensureProgressBar();
    setProgressBarPct(0);
  } else {
    removeProgressBar();
    resultsEl.innerHTML = '<p style="padding-left: 20px">Loading…</p>';
  }

  var effectiveHandle = getCollectionHandleForQuery(collectionHandle);
  syncURLCollectionHandle(effectiveHandle);

  // Detect fit finder ONCE and use this flag everywhere
  var fitFinderOn = isFitFinderMode();

  var progressiveOn =
    !fitFinderOn &&
    !(typeof __keyword === 'string' && __keyword.trim().length > 0) &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );

  var progressiveOn =
    !fitFinderOn &&
    !(typeof __keyword === 'string' && __keyword.trim().length > 0) &&
    (
      ((getInjurySelections() || []).length > 0) ||
      ((getColorSelections()  || []).length > 0)
    );

  // ✅ Progressive rendering ONLY for Injury/Color (and only when not fit-finder)
  var progressiveOn =
    !fitFinderOn &&
    ((getInjurySelections() || []).length > 0 || (getColorSelections() || []).length > 0);

  // We keep Loading… until we render the first partial set
  var didPaintAny = false;

  // Track if we have shown at least one product yet (prevents “No products…” too early)
  var didPaintAny = false;

  var fetchPromise = fitFinderOn
    ? fetchProductsFitFinderCascade()
    : fetchProducts({
        first: PAGE_SIZE,

        // ✅ NEW: progress updates (only when progressiveOn)
        onProgress: progressiveOn ? function(pct){
          // Keep bar visible until the full promise resolves
          ensureProgressBar();
          setProgressBarPct(pct);
        } : null,

        // ✅ Existing: partial rendering (only when progressiveOn)
        onPartial: progressiveOn ? function(partial){
          if (!partial || !partial.nodes || !partial.nodes.length) return;

          didPaintAny = true;

          // Render partial immediately (no pagination/infinite here)
          currentNodes = partial.nodes.slice(0);
          renderProducts(currentNodes, false);
          setCount(getTotalShown());
          safeReinitSlick(resultsEl);
        } : null
      });

  fetchPromise
    .then(function (page) {

      resetPagination();

      var nodes = (page && page.nodes) || [];
      var pageInfo = (page && page.pageInfo) || { hasNextPage:false, endCursor:null };

      // Cache page 1 (final result becomes the truth)
      pageState.pages[1] = { nodes: nodes, pageInfo: pageInfo };
      pageState.cursors[1] = pageInfo.endCursor || null;
      pageState.maxFetched = 1;
      pageState.current = 1;

      // ✅ CRITICAL: when Fit Finder is ON, NEVER allow infinite scroll / paging
      if (fitFinderOn) {
        pageState.hasNext = false;

        try {
          if (__inf && __inf.observer) __inf.observer.disconnect();
        } catch(_){}

        var infWrap = document.getElementById('sf-infinite-wrap');
        if (infWrap) infWrap.remove();

        var pag = document.getElementById('sf-pagination');
        if (pag) pag.remove();
      } else {
        pageState.hasNext = !!pageInfo.hasNextPage;
      }

      // If progressive already painted some products, this will just “finalize” the list.
      // If nothing was painted, this is the first render and replaces Loading… normally.
      currentNodes = nodes.slice(0);
      renderProducts(currentNodes, false);
      setCount(getTotalShown());
      safeReinitSlick(resultsEl);

      // Only render pagination + infinite scroll when NOT fit finder
      if (!fitFinderOn) {
        renderPagination();
        ensureInfiniteSentinel();
        ensureInfiniteObserver();
      }

      rIC(function(){ ensureSliderMaxForHandle(effectiveHandle); });
      // Progressive mode: bar stays until we finish the scan + final render
      if (progressiveOn) {
        setProgressBarPct(100);
        // remove it after final UI is painted (one tick)
        setTimeout(removeProgressBar, 0);
      }
    })
    .catch(function(){

      // If progressive mode never found a match, Loading… will still be visible.
      // This catch is for actual request errors.
      if (resultsEl) resultsEl.innerHTML = '<p>There was a problem loading products.</p>';
      if (countEl) countEl.textContent = '';
      removeProgressBar();
    });
}
 


  // Optional basic styles for the simple fallback grid (kept in case Slick/CSS not present)
  (function injectStyles() {
    var style = document.createElement('style');
    style.textContent =
      '#sf-metafield-filters{padding:.5rem 0}' +
      '#sf-metafield-filters .sf-filter-list label{display:inline-block;margin-right:1rem}' +
      '#sf-results .boxes-wrapper{gap:16px}' +
      '.sf-thumb{aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;overflow:hidden}' +
      '.sf-thumb img{max-width:100%;max-height:100%}';
    document.head.appendChild(style);
  })();

  // === ADD: goes right above "// Hook up buttons"
  function clearAllAndSearch(){
    __bulkClearing = true;
    if (resultsEl) resultsEl.innerHTML = '<p style="padding-left: 20px">Loading…</p>';

    // Uncheck everything
    Array.prototype.slice.call(
      document.querySelectorAll('#sf-metafield-filters input[type="checkbox"]')
    ).forEach(function (c) { c.checked = false; });

    // Clear per-category
    Object.keys(CATEGORY_DEFS).forEach(clearCategory);

    // Clear URL filters + route back to original handle
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('filter.v.price.gte');
      u.searchParams.delete('filter.v.price.lte');
      Object.keys(URL_META_MAP).forEach(function(param){
        while (u.searchParams.has(param)) u.searchParams.delete(param);
      });
      var parts = u.pathname.split('/').filter(Boolean);
      var idx = parts.indexOf('collections');
      if (idx !== -1 && parts[idx + 1] && parts[idx + 1] !== collectionHandle) {
        parts[idx + 1] = collectionHandle;
        u.pathname = '/' + parts.join('/');
      }
      history.replaceState(null, '', u.toString());
    } catch (_) {}

    // Reset price slider UI
    (function(){
      var minR = document.getElementById('minRange');
      var maxR = document.getElementById('maxRange');
      var minVal = document.getElementById('minVal');
      var maxVal = document.getElementById('maxVal');
      var fill   = document.getElementById('rangeFill');
      if (!minR || !maxR) return;
      var minBound = Number(minR.min || 0);
      var maxBound = Number(maxR.max || maxR.value || 0);
      minR.value = String(minBound);
      maxR.value = String(maxBound);
      if (minVal) minVal.textContent = String(minR.value);
      if (maxVal) maxVal.textContent = String(maxR.value);
      if (fill) {
        var denom = (maxBound - minBound) || 1;
        var left  = ((Number(minR.value) - minBound) / denom) * 100;
        var right = ((Number(maxR.value) - minBound) / denom) * 100;
        fill.style.left  = left + '%';
        fill.style.width = (right - left) + '%';
      }
    })();

    __lastSliderHandle = null;                 // force re-eval of slider bounds
    syncURLCollectionHandle(collectionHandle); // ensure path is original

    requestAnimationFrame(function(){
      __bulkClearing = false;
      var pag = document.getElementById('sf-pagination');
      if (pag) pag.remove();

      runSearch();
    });
  }

  function clearAllUIWithoutSearch(preservePath){
    preservePath = (preservePath === true); // default false unless explicitly true

    __bulkClearing = true;


    // Uncheck everything
    Array.prototype.slice.call(
      document.querySelectorAll('#sf-metafield-filters input[type="checkbox"]')
    ).forEach(function (c) { c.checked = false; });

    // Clear per-category
    Object.keys(CATEGORY_DEFS).forEach(clearCategory);

    // Clear URL query params, but only reset the PATH handle if preservePath === false
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('filter.v.price.gte');
      u.searchParams.delete('filter.v.price.lte');
      Object.keys(URL_META_MAP).forEach(function(param){
        while (u.searchParams.has(param)) u.searchParams.delete(param);
      });

      if (!preservePath) {
        var parts = u.pathname.split('/').filter(Boolean);
        var idx = parts.indexOf('collections');
        if (idx !== -1 && parts[idx + 1] && parts[idx + 1] !== collectionHandle) {
          parts[idx + 1] = collectionHandle;
          u.pathname = '/' + parts.join('/');
        }
      }
      history.replaceState(null, '', u.toString());
    } catch (_) {}


    // Reset price slider UI
    (function(){
      var minR = document.getElementById('minRange');
      var maxR = document.getElementById('maxRange');
      var minVal = document.getElementById('minVal');
      var maxVal = document.getElementById('maxVal');
      var fill   = document.getElementById('rangeFill');
      if (!minR || !maxR) return;
      var minBound = Number(minR.min || 0);
      var maxBound = Number(maxR.max || maxR.value || 0);
      minR.value = String(minBound);
      maxR.value = String(maxBound);
      if (minVal) minVal.textContent = String(minR.value);
      if (maxVal) maxVal.textContent = String(maxR.value);
      if (fill) {
        var denom = (maxBound - minBound) || 1;
        var left  = ((Number(minR.value) - minBound) / denom) * 100;
        var right = ((Number(maxR.value) - minBound) / denom) * 100;
        fill.style.left  = left + '%';
        fill.style.width = (right - left) + '%';
      }
    })();

    __lastSliderHandle = null;
    if (!preservePath) {
      syncURLCollectionHandle(collectionHandle);
    }


    __bulkClearing = false;
  }


  // ---- Debounced search trigger (centralized) ----
  function requestSearch() {
    // Skip while we're mass-editing the UI (prechecking from URL, clearing, etc.)
    if (__bulkClearing) return;

    if (requestSearch._timer) clearTimeout(requestSearch._timer);
    requestSearch._timer = setTimeout(function () {
      requestSearch._timer = null;
      runSearch();
    }, 120); // swallow bursts of back-to-back changes
  }


  // Hook up buttons

  // --- Keyword search box ---
  // --- Keyword search (shared helper + sidebar input wiring) ---
  function setKeywordAndSearch(q){
    __keyword = String(q || '').trim();

    // mirror into the sidebar box if present
    var kbox = document.getElementById('keyword-search-input');
    if (kbox) kbox.value = __keyword;

    // behave exactly like your old sidebar keyword handler
    clearAllUIWithoutSearch(true); // keep current womens/… handle
    resetPagination();
    runSearch();
  }
  // expose for header to call when we're already on a collection page
  window.__SF_setKeywordAndSearch = setKeywordAndSearch;

  (function(){
    var box = document.getElementById('keyword-search-input');
    if (!box) return;

    var t;
    box.addEventListener('input', function(){
      if (t) clearTimeout(t);
      t = setTimeout(function(){
        setKeywordAndSearch(box.value || '');
      }, 250); // debounce
    });
  })();


  if (btnApply) btnApply.addEventListener('click', runSearch);

  if (btnClear) btnClear.addEventListener('click', function (e) {
    // Stop form submit / bubbling just in case this lives inside a <form>
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();

    __bulkClearing = true;

    __keyword = '';
    var kbox = document.getElementById('keyword-search-input');
    if (kbox) kbox.value = '';


    // 0) Show loading immediately so users see feedback
    if (resultsEl) resultsEl.innerHTML = '<p style="padding-left: 20px">Loading…</p>';

    // 1) Uncheck ALL checkboxes (masters + children)
    Array.prototype.slice.call(
      document.querySelectorAll('#sf-metafield-filters input[type="checkbox"]')
    ).forEach(function (c) { c.checked = false; });

    // 2) Also clear via category API (covers gender groups too)
    Object.keys(CATEGORY_DEFS).forEach(clearCategory);

    // 3) Remove ALL URL-based filters (price + mapped metafields)
    (function resetURL(){
      try {
        var u = new URL(window.location.href);

        // Remove price filters
        u.searchParams.delete('filter.v.price.gte');
        u.searchParams.delete('filter.v.price.lte');

        // Remove mapped metafield params
        Object.keys(URL_META_MAP).forEach(function(param){
          while (u.searchParams.has(param)) u.searchParams.delete(param);
        });

        // Decide the path after clearing:
        // - If currently on /collections/all-footwear → go to /collections/mens-footwear-1
        // - If currently on /collections/all-apparel  → go to /collections/mens-apparel-1
        // - Otherwise, if we're on a women-specific footwear/apparel page, also go to the men's handle.
        var parts = u.pathname.split('/').filter(Boolean);
        var curHandle = (parts[0] === 'collections' && parts[1]) ? parts[1] : null;

        var footwearAlls = { 'all-footwear': 1 };
        var apparelAlls  = { 'all-apparel': 1 };
        var footwearWomens = { 'womens-footwear-1': 1 };
        var apparelWomens  = { 'womens-apparel-1': 1 };

        if (curHandle && (footwearAlls[curHandle] || footwearWomens[curHandle])) {
          parts[1] = 'mens-footwear-1';
        } else if (curHandle && (apparelAlls[curHandle] || apparelWomens[curHandle])) {
          parts[1] = 'mens-apparel-1';
        } else {
          // Fallback: if we’re clearly in footwear/apparel families, favor men’s.
          if (curHandle && curHandle.indexOf('footwear') !== -1) {
            parts[1] = 'mens-footwear-1';
          } else if (curHandle && (curHandle.indexOf('apparel') !== -1 || curHandle.indexOf('clothing') !== -1)) {
            parts[1] = 'mens-apparel-1';
          } else {
            // otherwise keep the original handle; nothing to do
          }
        }

        u.pathname = '/' + parts.join('/');
        history.replaceState(null, '', u.toString());
      } catch (e) { /* ignore */ }
    })();


    // 4) Reset the price slider UI
    (function resetSliderUI(){
      var minR = document.getElementById('minRange');
      var maxR = document.getElementById('maxRange');
      var minVal = document.getElementById('minVal');
      var maxVal = document.getElementById('maxVal');
      var fill = document.getElementById('rangeFill');

      if (!minR || !maxR) return;

      var minBound = Number(minR.min || 0);
      var maxBound = Number(maxR.max || maxR.value || 0);

      minR.value = String(minBound);
      maxR.value = String(maxBound);

      if (minVal) minVal.textContent = String(minR.value);
      if (maxVal) maxVal.textContent = String(maxR.value);

      if (fill) {
        var denom = (maxBound - minBound) || 1;
        var leftPct  = ((Number(minR.value) - minBound) / denom) * 100;
        var rightPct = ((Number(maxR.value) - minBound) / denom) * 100;
        fill.style.left  = leftPct + '%';
        fill.style.width = (rightPct - leftPct) + '%';
      }
    })();

    // 5) Force slider max recalculation next time (in case we switched collections before)
    __lastSliderHandle = null;

    // 6) Ensure URL path reflects original collection handle
    syncURLCollectionHandle(collectionHandle);

      // If we are on /collections/sale, keep sale-only mode after "Clear All"
      (function rearmSaleIfOnSaleRoute(){
        try{
          var parts = (new URL(window.location.href)).pathname.split('/').filter(Boolean);
          var onSaleCollection = (parts[0] === 'collections' && parts[1] === SALE_COLLECTION_HANDLE);
          if (onSaleCollection) {
            __handleOverride = null; // use real Sale collection
            var saleCb = document.getElementById('checkbox_show_only_sale_items');
            if (saleCb) saleCb.checked = true;
            if (!__lastNonSaleHandle) __lastNonSaleHandle = ALL_PRODUCTS_HANDLE;
          }
        } catch(_){}
      })();


    __bulkClearing = false;

    // 7) Defer the search one tick so the new URL/state is read cleanly
    setTimeout(function(){
      // Remove any old “Load more” button to avoid stale UI
      var moreBtn = document.getElementById('sf-load-more');
      if (moreBtn) moreBtn.remove();

      runSearch();
    }, 0);
  });



  // Re-run search as soon as any mapped checkbox toggles
  Object.keys(CHECKBOX_MAP).forEach(function(id){
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', runSearch);
  });

    ['footwear_feel[]','footwear_activity[]','footwear_injury[]','footwear_width[]','footwear_color[]', FOOTWEAR_SIZE_INPUT_NAME]
    .forEach(function(nameAttr){

    document.querySelectorAll('input[name="' + nameAttr + '"]').forEach(function(el){
      el.addEventListener('change', function(){
        // NEW: always mirror current UI → URL first
        syncMappedParamsToURL();

        // If the user checked something in footwear, activate footwear (handles URL path + search)
        if (document.querySelector('input[name="' + nameAttr + '"]:checked')) {
          activateCategory('footwear');
        } else {
          if (__bulkClearing) return;
          requestSearch();
        }
      });
    });
  });



  


  // Re-run when user toggles sizes
  // document.querySelectorAll('input[name="' + FOOTWEAR_SIZE_INPUT_NAME + '"]').forEach(function(el){
  //   el.addEventListener('change', function(){
  //     if (__bulkClearing) return;
  //     requestSearch();
  //   });
  // });


  // Re-run when user toggles brands
  document.querySelectorAll('input[name="' + BRAND_INPUT_NAME + '"]').forEach(function(el){
    el.addEventListener('change', function(){
      // NEW: keep URL in sync (updates/removes ?brand=...)
      syncMappedParamsToURL();

      if (__bulkClearing) return;
      requestSearch();
    });
  });





  // Clothing → Type
  document.querySelectorAll('input[name="' + CLOTHING_TYPE_INPUT_NAME + '"]').forEach(function(el){
    el.addEventListener('change', function(){
      // NEW: keep URL in sync (updates/removes ?clothing-type=...)
      syncMappedParamsToURL();

      if (document.querySelector('input[name="' + CLOTHING_TYPE_INPUT_NAME + '"]:checked')) {
        activateCategory('clothing');
      } else {
        if (__bulkClearing) return;
        requestSearch();
      }
    });
  });


  // Clothing → Size
  document.querySelectorAll('input[name="' + CLOTHING_SIZE_INPUT_NAME + '"]').forEach(function(el){
    el.addEventListener('change', function(){
      // NEW: keep URL in sync if you ever map clothing sizes later
      syncMappedParamsToURL();

      if (document.querySelector('input[name="' + CLOTHING_SIZE_INPUT_NAME + '"]:checked')) {
        activateCategory('clothing');
      } else {
        if (__bulkClearing) return;
        requestSearch();
      }
    });
  });

  // ✅ Clothing → Color
  document.querySelectorAll('input[name="clothing_color[]"]').forEach(function(el){
    el.addEventListener('change', function(){
      // keep URL in sync later if you decide to map colors (optional)
      // syncMappedParamsToURL();

      if (document.querySelector('input[name="clothing_color[]"]:checked')) {
        activateCategory('clothing');
      } else {
        if (__bulkClearing) return;
        requestSearch();
      }
    });
  });

  // Clothing → Color
  document.querySelectorAll('input[name="clothing_color[]"]').forEach(function(el){
    el.addEventListener('change', function(){
      syncMappedParamsToURL(); // if you later map colors to URL, otherwise harmless
      if (__bulkClearing) return;
      requestSearch();
    });
  });






  // When user finishes dragging a price handle: sync URL and filter once.
  (function attachPriceChangeListeners(){
    var minR = document.getElementById('minRange');
    var maxR = document.getElementById('maxRange');
    if (!minR || !maxR) return;

    function applyPriceToURLAndSearch(){
      var u = new URL(window.location.href);
      u.searchParams.set('filter.v.price.gte', String(minR.value));
      u.searchParams.set('filter.v.price.lte', String(maxR.value));
      history.replaceState(null, '', u); // update URL without reload
      runSearch();
    }

    var priceTimer;
    function schedulePriceSearch(){
      if (priceTimer) clearTimeout(priceTimer);
      priceTimer = setTimeout(applyPriceToURLAndSearch, 150);
    }
    minR.addEventListener('change', schedulePriceSearch);
    maxR.addEventListener('change', schedulePriceSearch);

  })();

  // Re-run when user toggles Accessories (master or child types)
  // Master

  var accMaster = document.getElementById('acc-all');
  if (accMaster) {
    accMaster.addEventListener('change', function(){
      withSuppression('accessories', function(){
        if (accMaster.checked) {
          // Clear children (except the master)
          document.querySelectorAll('input[name="' + ACCESSORY_INPUT_NAME + '"]:checked')
            .forEach(function(c){ if (c !== accMaster) c.checked = false; });

          accMaster.checked = true;           // keep master ticked
          activateCategory('accessories');    // updates handle + runs search
          } else {
            if (__bulkClearing) return;
            requestSearch();
          }

      });
    });
  }


  var smrMaster = document.getElementById('smr-all');
  if (smrMaster) {
    smrMaster.addEventListener('change', function(){
      withSuppression('smr', function(){
        if (smrMaster.checked) {
          document.querySelectorAll('input[name="' + SMR_INPUT_NAME + '"]:checked')
            .forEach(function(c){ if (c !== smrMaster) c.checked = false; });

          smrMaster.checked = true;
          activateCategory('smr');
          } else {
            if (__bulkClearing) return;
            requestSearch();
          }

      });
    });
  }

  // Footwear master
  var fwMaster = document.getElementById('checkboxAllFootwear');
  if (fwMaster) {
    fwMaster.addEventListener('change', function(){
      withSuppression('footwear', function(){
        if (fwMaster.checked) {
          // Clear ALL footwear children (feel, activity, injury, size, gender)
          ['footwear_gender[]','footwear_feel[]','footwear_activity[]','footwear_injury[]','footwear_size[]']
            .forEach(function(nameAttr){
              document.querySelectorAll('input[name="' + nameAttr + '"]:checked')
                .forEach(function(el){ el.checked = false; });
            });

          // Reflect cleared selections in the URL
          syncMappedParamsToURL();

          // Also clear price filters from URL and reset the slider UI
          clearPriceFromURLAndResetSliderUI();

          fwMaster.checked = true;                   // keep master visibly ticked

          // ✅ Explicit route to unified collection (no activateCategory)
          syncURLCollectionHandle('all-footwear');
          runSearch();
        } else {
          // UNCHECKED → return to men's footwear explicitly
          syncMappedParamsToURL();
          clearPriceFromURLAndResetSliderUI();
          syncURLCollectionHandle('mens-footwear-1');
          runSearch();
        }
      });
    });
  }






  // Clothing master
  var clMaster = document.getElementById('checkboxAllClothing');
  if (clMaster) {
    clMaster.addEventListener('change', function(){
      withSuppression('clothing', function(){
        if (clMaster.checked) {
          // Clear ALL clothing children (gender, type, size)
          ['clothing_gender[]','clothing_type[]','clothing_size[]']
            .forEach(function(nameAttr){
              document.querySelectorAll('input[name="' + nameAttr + '"]:checked')
                .forEach(function(el){ el.checked = false; });
            });

          // Reflect cleared selections in the URL
          syncMappedParamsToURL();

          // Also clear price filters from URL and reset the slider UI
          clearPriceFromURLAndResetSliderUI();

          clMaster.checked = true;

          // ✅ Explicit route to unified collection (no activateCategory)
          syncURLCollectionHandle('all-apparel');
          runSearch();
        } else {
          // UNCHECKED → return to men's apparel explicitly
          syncMappedParamsToURL();
          clearPriceFromURLAndResetSliderUI();
          syncURLCollectionHandle('mens-apparel-1');
          runSearch();
        }
      });
    });
  }








  // Children
  document.querySelectorAll('input[name="' + ACCESSORY_INPUT_NAME + '"]').forEach(function(el){
    el.addEventListener('change', function(){
      if (document.querySelector('input[name="' + ACCESSORY_INPUT_NAME + '"]:checked')) {
        activateCategory('accessories');
      } else {
        if (__bulkClearing) return;
        requestSearch();
      }

    });
  });


  // Generic master behavior for every category in CATEGORY_DEFS
  Object.keys(CATEGORY_DEFS).forEach(function(key){
    var def = CATEGORY_DEFS[key];
    if (!def) return;

    def.childNames.forEach(function(nameAttr){
      document.querySelectorAll('input[name="' + nameAttr + '"]').forEach(function(el){
        el.addEventListener('change', function(e){
          if (__suppressMasterSync[key]) return;

          // If this event came from the master checkbox, ignore it here.
          if (def.masterId) {
            var master = document.getElementById(def.masterId);
            if (master && e.target === master) return;
          }

          // Keep master (“All …”) visually correct when REAL children change
          syncMasterWithChildren(key);
        });
      });
    });
  });




  // Children
  document.querySelectorAll('input[name="' + SMR_INPUT_NAME + '"]').forEach(function(el){
    el.addEventListener('change', function(){
      if (document.querySelector('input[name="' + SMR_INPUT_NAME + '"]:checked')) {
        activateCategory('smr');
      } else {
        if (__bulkClearing) return;
        requestSearch();
      }

    });
  });



  // Footwear → Gender (make checkboxes behave like radios, switch URL, search)
  document.querySelectorAll('input[name="footwear_gender[]"]').forEach(function(el){
    el.addEventListener('change', function(){
      // enforce radio behavior immediately
      if (el.checked) {
        document.querySelectorAll('input[name="footwear_gender[]"]').forEach(function(other){
          if (other !== el) other.checked = false;
        });
      }
      // route with correct handle
      activateCategory('footwear');
    });
  });


  // Clothing → Gender (radio behavior, switch URL, search)
  document.querySelectorAll('input[name="clothing_gender[]"]').forEach(function(el){
    el.addEventListener('change', function(){
      if (el.checked) {
        document.querySelectorAll('input[name="clothing_gender[]"]').forEach(function(other){
          if (other !== el) other.checked = false;
        });
      }
      activateCategory('clothing');
    });
  });



  // --- NEW: delegated fallback so the sale checkbox always triggers runSearch ---
// --- Sale-only toggle: DO NOT change collection handle.
// Keep current collection (mens/womens/etc) and add/remove ?sale=true
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    if (t.id !== 'checkbox_show_only_sale_items') return;
    if (__bulkClearing) return;

    try {
      var u = new URL(window.location.href);
      var parts = u.pathname.split('/').filter(Boolean);
      var currentHandle = (parts[0] === 'collections' && parts[1]) ? parts[1] : null;

      // If user is currently on the dedicated Sale collection route,
      // keep your old behavior (optional): allow "uncheck" to restore back.
      var onSaleCollection = (currentHandle && String(currentHandle).toLowerCase() === String(SALE_COLLECTION_HANDLE).toLowerCase());

      if (t.checked) {
        // If we're already on /collections/<sale-handle>, do nothing special.
        // Otherwise, just set a URL flag and re-run search in-place.
        if (!onSaleCollection) {
          u.searchParams.set('sale', 'true');
          history.replaceState(null, '', u.toString());
        }
        requestSearch();
        return;
      } else {
        // Remove the URL flag
        u.searchParams.delete('sale');
        history.replaceState(null, '', u.toString());

        // If user is literally on the sale collection page and unchecks,
        // restore to last non-sale handle if you have it.
        if (onSaleCollection && __lastNonSaleHandle) {
          syncURLCollectionHandle(__lastNonSaleHandle);
        }

        requestSearch();
        return;
      }
    } catch (_) {
      // Fallback: just re-run search
      requestSearch();
    }
  });

 


  try {
    window.addEventListener('touchstart', function(){}, { passive: true });
    window.addEventListener('wheel', function(){}, { passive: true });
  } catch(_){}


  // --- Force "Sale-only" when user lands on /collections/sale ---
  (function bootSaleLanding(){
    try {
      var parts = (new URL(window.location.href)).pathname.split('/').filter(Boolean);
      var onSaleCollection = (parts[0] === 'collections' && parts[1] === SALE_COLLECTION_HANDLE);
      if (onSaleCollection) {
        __handleOverride = null; // use real Sale collection

        // Visually tick the checkbox (no extra client-side sale filter will be applied on /sale)
        var saleCb = document.getElementById('checkbox_show_only_sale_items');
        if (saleCb) saleCb.checked = true;

        // Do NOT set __lastNonSaleHandle here; let it be set only when users check the box elsewhere.
      }
    } catch(_){}
  })();



  // 1) Mirror URL params → checkboxes & price
  applyURLParamsToUI();

  // If fw_all=1 is in the URL, visually tick the master checkbox before the first search
  (function(){
    try{
      if (isAllFootwearParamOn()) {
        var m = document.getElementById('checkboxAllFootwear');
        if (m) m.checked = true;
      }
    }catch(_){}
  })();


  // 2) If we arrived with a keyword (?q= or ?keyword=), run keyword search and skip default run
// 2) If we arrived with a keyword (?k=, ?q= or ?keyword=), run keyword search
(function(){
  var params = getURLParams();
  var q = (params.get('k') || params.get('q') || params.get('keyword') || '').trim();
  if (q) {
    setKeywordAndSearch(q);
  } else {
    runSearch();
  }
})();


  // --- Header search box wiring ---
  (function(){
    var headerBox = document.getElementById('header-products-search-bar');
    if (!headerBox) return;

    function go(q){
      q = (q || '').trim();
      if (!q) return;

      // Detect if we're currently on /collections/all
      var onAll = (function(){
        try{
          var u = new URL(window.location.href);
          var parts = u.pathname.split('/').filter(Boolean);
          return (parts[0] === 'collections' && parts[1] === 'all');
        }catch(_){ return false; }
      })();

      if (onAll) {
        // If the collections script is loaded, update the search in-place
        if (window.__SF_setKeywordAndSearch) {
          window.__SF_setKeywordAndSearch(q);
        } else {
          // Fallback: reload page with ?q=
          var u = new URL(window.location.href);
          u.searchParams.set('q', q);
          window.location.href = u.toString();
        }
      } else {
        // Navigate to /collections/all with ?q=
        window.location.href = '/collections/all?q=' + encodeURIComponent(q);
      }
    }

    // Run search when pressing Enter in the header box
    headerBox.addEventListener('keydown', function(e){
      if (e.key === 'Enter') {
        e.preventDefault();
        go(headerBox.value);
      }
    });

    // Optional: if there's a button next to the header input
    var btn = document.getElementById('header-products-search-btn');
    if (btn) {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        go(headerBox.value);
      });
    }
  })();


})();



$(document).ready(function () {

  if (window.location.pathname === "/collections/shop-all-running-shoes-kansas-city") {

    setTimeout(function () {

      // 1️⃣ Open the main "Category" accordion first
      var $category = $("#collapseCategory");

      if ($category.length) {
        $category.addClass("show");

        var $categoryBtn = $('[data-bs-target="#collapseCategory"]');
        $categoryBtn.removeClass("collapsed").attr("aria-expanded", "true");
      }

      // 2️⃣ Now open the 4 child accordions
      var accordionIds = [
        "#collapseFootwear",
        "#collapseClothing",
        "#collapseAccessories",
        "#collapseSMR"
      ];

      accordionIds.forEach(function(id) {
        var $collapse = $(id);

        if ($collapse.length) {
          $collapse.addClass("show");

          var $button = $('[data-bs-target="' + id + '"]');
          $button.removeClass("collapsed").attr("aria-expanded", "true");
        }
      });

    }, 200);

  }

});